/* tslint:disable */
/* eslint-disable */
/**
 * gateway API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';


export const Aggregator = {
    Min: 'MIN',
    Max: 'MAX',
    Avg: 'AVG',
    Mean: 'MEAN',
    Sum: 'SUM',
    Count: 'COUNT',
    Stddev: 'STDDEV',
    Med: 'MED',
    Mediane: 'MEDIANE',
    Ratio: 'RATIO',
} as const;

export type Aggregator = typeof Aggregator[keyof typeof Aggregator];



export const AggregatorType = {
    Day: 'DAY',
    Month: 'MONTH',
    Year: 'YEAR',
    All: 'ALL',
} as const;

export type AggregatorType = typeof AggregatorType[keyof typeof AggregatorType];


export interface AliasTrace {
    'requested'?: string;
    'conceptId'?: string;
    'rank'?: string;
    'label'?: string;
    'matchedLang'?: string;
    'expanded'?: Array<ExpandedEntry>;
}

export const AnalysisType = {
    Correlation: 'CORRELATION',
    Distance: 'DISTANCE',
    StatsTest: 'STATS_TEST',
    AnomalyDetection: 'ANOMALY_DETECTION',
    TrendAnalysis: 'TREND_ANALYSIS',
    ShapeSimilarity: 'SHAPE_SIMILARITY',
    LagCorrelation: 'LAG_CORRELATION',
    Seasonality: 'SEASONALITY',
    Stationarity: 'STATIONARITY',
    DistributionShift: 'DISTRIBUTION_SHIFT',
    Clustering: 'CLUSTERING',
} as const;

export type AnalysisType = typeof AnalysisType[keyof typeof AnalysisType];


export interface AnalyticsDto {
    'id'?: string;
    'name'?: string;
    'description'?: string;
    'type'?: string;
    'instance'?: string;
    'queries'?: ComponentsDto;
    'startTime'?: string;
    'endTime'?: string;
    'status'?: AnalyticsStatusEnum;
    'nbTasks'?: number;
    'nbFinishedTasks'?: number;
    'data'?: { [key: string]: PromiseValues3; };
    'engines'?: Array<string>;
    'engineParams'?: { [key: string]: { [key: string]: any; }; };
    'pipeline'?: Array<AnalyticsPipelineStep>;
    'pipelineState'?: { [key: string]: PipelineStepState; };
    'pipelineEdges'?: Array<PipelineEdge>;
}



export const AnalyticsLanguage = {
    Python: 'PYTHON',
    R: 'R',
} as const;

export type AnalyticsLanguage = typeof AnalyticsLanguage[keyof typeof AnalyticsLanguage];


export interface AnalyticsPipelineStep {
    'stepId'?: string;
    'engine'?: string;
    'params'?: { [key: string]: any; };
    'nextStepIds'?: Array<string>;
    'dataFromStepId'?: string;
    'connectedOutputs'?: Array<string>;
}

export const AnalyticsStatusEnum = {
    Init: 'INIT',
    End: 'END',
    Running: 'RUNNING',
    Deleting: 'DELETING',
    EndDeleting: 'END_DELETING',
} as const;

export type AnalyticsStatusEnum = typeof AnalyticsStatusEnum[keyof typeof AnalyticsStatusEnum];


export interface AnalyticsTask {
    'id'?: string;
    'idAnalytics'?: string;
    'model'?: string;
    'version'?: string;
    'modelLabel'?: string;
    'modelDescription'?: string;
    'groupId'?: string;
    'groupLabel'?: string;
    'analysisType'?: AnalysisType;
    'outputInterpretation'?: string;
    'modelOutputs'?: Array<ModelOutput>;
    'timeSeriesIds'?: Array<string>;
    'stepId'?: string;
    'stepNbTasks'?: number;
    'stepPredecessorCount'?: number;
    'parentStepId'?: string;
    'connectedOutputs'?: Array<string>;
    'routingKey'?: string;
    'exchange'?: string;
    'dataEndpoint'?: string;
    'resultEndpoint'?: string;
    'timingEndpoint'?: string;
    'params'?: { [key: string]: any; };
    'alignSeries'?: boolean;
    'outputs'?: { [key: string]: any; };
    'nextSteps'?: Array<AnalyticsTask>;
}


export interface AnalyticsWResultsDto {
    'analytics'?: AnalyticsDto;
    'results'?: Array<AnalyticsTask>;
    'tmpResults'?: Array<AnalyticsTask>;
    'data'?: { [key: string]: Array<PromiseValues3>; };
    'catalog'?: Array<ModelConfig>;
}
export interface BugReportDto {
    'kind'?: string;
    'description'?: string;
    'path'?: string;
    'screenshotUrl'?: string;
    'screenshotBase64'?: string;
    'username'?: string;
    'pageStatus'?: string;
    'details'?: string;
    'contactFirstName'?: string;
    'contactLastName'?: string;
    'contactEmail'?: string;
}
export interface BuildLog {
    'id'?: string;
    'modelId'?: string;
    'image'?: string;
    'status'?: string;
    'logs'?: string;
    'initLogs'?: string;
    'startedAt'?: string;
    'finishedAt'?: string;
}
export interface CmsViewDto {
    'id'?: string;
    'color'?: string;
    'config'?: { [key: string]: any; };
    'welcome'?: { [key: string]: any; };
    'reports'?: { [key: string]: any; };
    'dashboards'?: { [key: string]: any; };
    'origins'?: { [key: string]: any; };
    'contact'?: { [key: string]: any; };
    'manuel'?: boolean;
    'views'?: boolean;
    'explore'?: { [key: string]: any; };
    'imports'?: boolean;
    'analytics'?: boolean;
    'auth'?: { [key: string]: boolean; };
    'pages'?: Array<PagesCms>;
}
export interface CodeGenerator {
    'description'?: string;
    'header'?: string;
    'perItem'?: string;
    'separator'?: string;
    'footer'?: string;
}
export interface ColumnProfile {
    'columnName'?: string;
    'conceptType'?: string;
    'hidden'?: boolean;
    'lang'?: string;
    'aliasOf'?: string;
    'orAliases'?: Array<string>;
}
export interface ComponentsDto {
    'id'?: string;
    'render'?: string;
    'tags'?: boolean;
    'tools'?: boolean;
    'size'?: SizeConfig;
    'title'?: string;
    'description'?: string;
    'queries'?: Array<PromiseQuery>;
}
export interface Concept {
    'id'?: string;
    'type'?: string;
    'rank'?: string;
    'parentId'?: string;
    'labels'?: { [key: string]: string; };
    'synonyms'?: { [key: string]: Array<string>; };
    'bindings'?: { [key: string]: Array<string>; };
    'active'?: boolean;
}
export interface Config {
    'scoreMode'?: string;
    'best'?: number;
    'worst'?: number;
    'goodThreshold'?: number;
    'okThreshold'?: number;
}
export interface ContactDto {
    'email'?: string;
    'subject'?: string;
    'content'?: string;
}
export interface DashboardModelBlockDto {
    'title'?: string;
    'description'?: string;
    'renderer'?: Array<RendererDto>;
}
export interface DashboardModelDto {
    'id'?: string;
    'name'?: string;
    'views'?: Array<DashboardModelBlockDto>;
}
export interface DataDto {
    'instance'?: string;
    'filename'?: string;
    'tags'?: { [key: string]: string; };
    'values'?: { [key: string]: PromiseData; };
    'geo'?: GeoInfo;
    'userInfo'?: UserInfo;
    'time'?: string;
}
export interface DataResultDto {
    'data'?: Array<PromiseValues3>;
    'aliases'?: { [key: string]: Array<AliasTrace>; };
}
export interface DbStatDto {
    'groupValue'?: string;
    'timeMin'?: string;
    'timeMax'?: string;
    'hasNational'?: boolean;
    'hasRegion'?: boolean;
    'hasBassin'?: boolean;
    'count'?: number;
    'tagArrays'?: { [key: string]: Array<string>; };
    'groupLabel'?: string;
    'tagArrayLabels'?: { [key: string]: { [key: string]: string; }; };
}
export interface DbStatQueryDto {
    'groupByTag'?: string;
    'arrayTags'?: Array<string>;
    'filename'?: string;
    'geoCountryValue'?: string;
}
export interface DockerConfigImage {
    'registry'?: string;
    'image'?: string;
    'tag'?: string;
    'language'?: AnalyticsLanguage;
    'sourceMode'?: ImageSourceMode;
    'files'?: { [key: string]: string; };
}


export interface EngineHealth {
    'modelId'?: string;
    'deployment'?: string;
    'pods'?: Array<PodHealth>;
}
export interface EngineStatus {
    'name'?: string;
    'image'?: string;
    'replicas'?: number;
    'readyReplicas'?: number;
    'availableReplicas'?: number;
    'modelId'?: string;
    'groupId'?: string;
    'groupLabel'?: string;
    'analysisType'?: string;
    'maxReplicas'?: number;
}
export interface ExpandedEntry {
    'dbValue'?: string;
    'conceptId'?: string;
    'label'?: string;
}
export interface GeoInfo {
    'codeBassin'?: string;
    'codeSsBassin'?: string;
    'department'?: string;
    'region'?: string;
    'country'?: string;
}

export const GeoKeyType = {
    Country: 'COUNTRY',
    Pays: 'PAYS',
    Region: 'REGION',
    Departement: 'DEPARTEMENT',
    Commune: 'COMMUNE',
    Ville: 'VILLE',
    Gps: 'GPS',
    SousBassinHydrographique: 'SOUS_BASSIN_HYDROGRAPHIQUE',
    BassinHydrographique: 'BASSIN_HYDROGRAPHIQUE',
} as const;

export type GeoKeyType = typeof GeoKeyType[keyof typeof GeoKeyType];


export interface GeoQuery {
    'type'?: GeoKeyType;
    'filters'?: { [key: string]: Array<string>; };
    'selector'?: { [key: string]: Array<string>; };
}



export const ImageSourceMode = {
    Build: 'BUILD',
    Pull: 'PULL',
    None: 'NONE',
} as const;

export type ImageSourceMode = typeof ImageSourceMode[keyof typeof ImageSourceMode];


export interface Instance {
    'databases'?: Array<string>;
    'groups'?: Array<string>;
    'role'?: PromiseUserRole;
    'attributes'?: { [key: string]: string; };
}


export interface LanguageTemplate {
    'id'?: string;
    'language'?: AnalyticsLanguage;
    'label'?: string;
    'description'?: string;
    'files'?: { [key: string]: string; };
    'filesInfo'?: { [key: string]: TemplateFile; };
    'codeGenerators'?: { [key: string]: CodeGenerator; };
}


export interface Limits {
    'cpuLimit'?: string;
    'memoryLimit'?: string;
    'cpuRequest'?: string;
    'memoryRequest'?: string;
}
export interface LineDto {
    'id'?: string;
    'title'?: string;
    'description'?: string;
    'components'?: Array<ComponentsDto>;
}
export interface ListResultDtoListString {
    'data'?: Array<string>;
    'aliases'?: { [key: string]: Array<AliasTrace>; };
    'valueLabels'?: { [key: string]: string; };
}
export interface ListResultDtoMapStringListString {
    'data'?: { [key: string]: Array<string>; };
    'aliases'?: { [key: string]: Array<AliasTrace>; };
    'valueLabels'?: { [key: string]: { [key: string]: string; }; };
}
export interface LockedRange {
    'startLine'?: number;
    'endLine'?: number;
    'startTag'?: string;
    'endTag'?: string;
    'reason'?: string;
    'generatedFrom'?: string;
}
export interface ModelConfig {
    'id'?: string;
    'label'?: string;
    'description'?: string;
    'version'?: string;
    'groupId'?: string;
    'groupLabel'?: string;
    'analysisType'?: AnalysisType;
    'config'?: Config;
    'series'?: Array<Series>;
    'outputInterpretation'?: string;
    'outputs'?: Array<ModelOutput>;
    'params'?: Array<ModelParam>;
    'alignSeries'?: boolean;
    'visualization'?: VisualizationConfig;
    'image'?: DockerConfigImage;
    'replicas'?: number;
    'limits'?: Limits;
    'rabbitmq'?: RabbitMqConfig;
}


export interface ModelOutput {
    'name'?: string;
    'label'?: string;
    'dataType'?: string;
    'description'?: string;
    'unit'?: string;
}
export interface ModelParam {
    'name'?: string;
    'label'?: string;
    'type'?: string;
    'default'?: any;
    'min'?: number;
    'max'?: number;
    'options'?: Array<string>;
    'description'?: string;
}
export interface NotificationDto {
    'id'?: string;
    'type'?: string;
    'status'?: string;
    'createdAt'?: number;
    'updatedAt'?: number;
    'username'?: string;
    'path'?: string;
    'pageStatus'?: string;
    'description'?: string;
    'details'?: string;
    'contactFirstName'?: string;
    'contactLastName'?: string;
    'contactEmail'?: string;
    'institution'?: string;
    'email'?: string;
    'subject'?: string;
    'content'?: string;
    'screenshotBase64'?: string;
    'screenshotFilename'?: string;
    'resolutionNote'?: string;
    'resolvedBy'?: string;
    'resolvedAt'?: number;
}
export interface NotificationSubscriptionDto {
    'admin'?: string;
    'types'?: Array<string>;
    'lastSeenAt'?: number;
}
export interface OwnerDto {
    'id'?: string;
    'instance'?: string;
}
export interface PagesCms {
    'type'?: string;
    'auth'?: boolean;
    'roles'?: Array<string>;
    'config'?: { [key: string]: any; };
}
export interface PasswordResetRequestDto {
    'email'?: string;
}
export interface PipelineEdge {
    'source'?: string;
    'sourceHandle'?: string;
    'target'?: string;
    'targetHandle'?: string;
}
export interface PipelineStepState {
    'stepId'?: string;
    'engine'?: string;
    'nbTasks'?: number;
    'dispatched'?: boolean;
    'nextStepIds'?: Array<string>;
}
export interface PodHealth {
    'podName'?: string;
    'podIp'?: string;
    'phase'?: string;
    'healthy'?: boolean;
    'ready'?: boolean;
}
export interface PodLogEntry {
    'podName'?: string;
    'phase'?: string;
    'logs'?: string;
}
export interface PodLogs {
    'modelId'?: string;
    'deployment'?: string;
    'pods'?: Array<PodLogEntry>;
}
export interface PromiseData {
    'aggregator'?: string;
    'type'?: string;
    'value'?: number;
    'unit'?: string;
}
export interface PromiseHaving {
    'column'?: string;
    'aggregator'?: string;
    'operator'?: string;
    'value'?: number;
}
export interface PromiseKeyValue {
    'key'?: string;
    'aggregator'?: Aggregator;
    'unit'?: string;
}


export interface PromiseOpenId {
    'access_token'?: string;
    'token_type'?: string;
    'refresh_token'?: string;
    'expires_in'?: number;
    'refresh_expires_in'?: number;
    'access_expires_in'?: number;
    'scope'?: string;
    'pendingUsersCount'?: number;
    'analyticsSummaries'?: Array<AnalyticsDto>;
}
export interface PromiseQuery {
    'geo'?: GeoQuery;
    'filters'?: { [key: string]: Array<string>; };
    'selector'?: { [key: string]: Array<string>; };
    'columns'?: Array<string>;
    'values'?: Array<PromiseKeyValue>;
    'having'?: Array<PromiseHaving>;
    'timeRange'?: TimeRange;
    'aliases'?: { [key: string]: Array<AliasTrace>; };
    'groupValueRewrites'?: { [key: string]: { [key: string]: string; }; };
    'columnRewrites'?: { [key: string]: string; };
    'orSelectors'?: Array<{ [key: string]: Array<string>; }>;
}
export interface PromiseUser {
    'login'?: string;
    'firstName'?: string;
    'lastName'?: string;
    'email'?: string;
    'institution'?: string;
    'password'?: string;
    'validated'?: boolean;
    'instances'?: { [key: string]: Instance; };
}

export const PromiseUserRole = {
    Admin: 'ADMIN',
    User: 'USER',
    Provider: 'PROVIDER',
    Writer: 'WRITER',
} as const;

export type PromiseUserRole = typeof PromiseUserRole[keyof typeof PromiseUserRole];


export interface PromiseUserShort {
    'id'?: string;
    'firstName'?: string;
    'lastName'?: string;
    'institution'?: string;
    'attributes'?: { [key: string]: string; };
}
export interface PromiseValues3 {
    'geoKey'?: string;
    'key'?: string;
    'tags'?: { [key: string]: string; };
    'values'?: { [key: string]: Array<PromiseData>; };
    'tagLabels'?: { [key: string]: string; };
}
export interface RabbitMqConfig {
    'exchange'?: string;
    'exchangeType'?: string;
    'routingKey'?: string;
    'queue'?: string;
    'dlxExchange'?: string;
    'dlqQueue'?: string;
    'prefetchCount'?: number;
    'maxRetries'?: number;
    'retryBaseDelay'?: number;
}
export interface RabbitQueueInfo {
    'name'?: string;
    'messages'?: number;
    'messagesReady'?: number;
    'messagesUnacked'?: number;
    'consumers'?: number;
    'state'?: string;
    'messageRate'?: number;
    'publishRate'?: number;
    'idleSince'?: string;
}
export interface RendererDto {
    'name'?: string;
    'description'?: string;
    'components'?: Array<ComponentsDto>;
}
export interface ScaleRequest {
    'replicas'?: number;
}
export interface Series {
    'name'?: string;
    'label'?: string;
    'columnName'?: string;
    'dataType'?: string;
    'description'?: string;
}
export interface SizeConfig {
    'width'?: string;
    'height'?: string;
}
export interface TemplateFile {
    'description'?: string;
    'editable'?: boolean;
    'lockedRanges'?: Array<LockedRange>;
}
export interface TimeRange {
    'type'?: AggregatorType;
    'min'?: string;
    'max'?: string;
}


export interface UpdatePasswordDto {
    'login'?: string;
    'oldPassword'?: string;
    'newPassword'?: string;
}
export interface UpdateProfileDto {
    'login'?: string;
    'firstName'?: string;
    'lastName'?: string;
    'email'?: string;
    'institution'?: string;
}
export interface UserDto {
    'userName'?: string;
    'email'?: string;
    'nom'?: string;
    'prenom'?: string;
    'institution'?: string;
    'password'?: string;
}
export interface UserInfo {
    'userId'?: string;
    'insertionDate'?: string;
}
export interface ValidateUserDto {
    'login'?: string;
    'password'?: string;
}
export interface ViewDto {
    'id'?: string;
    'title'?: string;
    'description'?: string;
    'folder'?: string;
    'folderIcon'?: string;
    'folderColor'?: string;
    'owner'?: OwnerDto;
    'share'?: Array<string>;
    'shareGroups'?: Array<string>;
    'lines'?: Array<LineDto>;
}
export interface VisualizationConfig {
    'chartType'?: string;
    'interpretation'?: string;
    'bivariate'?: boolean;
    'valueLabel'?: string;
    'valueUnit'?: string;
    'valueMin'?: number;
    'valueMax'?: number;
    'invertScale'?: boolean;
}
export interface WebPushSubscriptionDto {
    'admin'?: string;
    'endpoint'?: string;
    'p256dh'?: string;
    'auth'?: string;
}
export interface WorkerStatus {
    'engineId'?: string;
    'name'?: string;
    'messages'?: number;
    'messagesReady'?: number;
    'messagesUnacked'?: number;
    'consumers'?: number;
    'state'?: string;
    'error'?: string;
}
export interface WsAuthResponse {
    'wsToken'?: string;
    'expiresAt'?: number;
}

/**
 * AnalyticsCtrlApi - axios parameter creator
 */
export const AnalyticsCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsIdDelete', 'id', id)
            const localVarPath = `/api/analytics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsIdGet', 'id', id)
            const localVarPath = `/api/analytics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsModelsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update One
         * @param {AnalyticsDto} analyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsPost: async (analyticsDto: AnalyticsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticsDto' is not null or undefined
            assertParamExists('apiAnalyticsPost', 'analyticsDto', analyticsDto)
            const localVarPath = `/api/analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(analyticsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restart Task
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsRestartIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsRestartIdGet', 'id', id)
            const localVarPath = `/api/analytics/restart/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get List Of Stopped Tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsStopGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/stop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stop Task
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsStopIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsStopIdGet', 'id', id)
            const localVarPath = `/api/analytics/stop/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsCtrlApi - functional programming interface
 */
export const AnalyticsCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnalyticsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsCtrlApi.apiAnalyticsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsCtrlApi.apiAnalyticsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyticsWResultsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsCtrlApi.apiAnalyticsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsModelsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModelConfig>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsModelsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsCtrlApi.apiAnalyticsModelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update One
         * @param {AnalyticsDto} analyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsPost(analyticsDto: AnalyticsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsPost(analyticsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsCtrlApi.apiAnalyticsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Restart Task
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsRestartIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsRestartIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsCtrlApi.apiAnalyticsRestartIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get List Of Stopped Tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsStopGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsStopGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsCtrlApi.apiAnalyticsStopGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stop Task
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsStopIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsStopIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsCtrlApi.apiAnalyticsStopIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalyticsCtrlApi - factory interface
 */
export const AnalyticsCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<AnalyticsDto>> {
            return localVarFp.apiAnalyticsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AnalyticsWResultsDto> {
            return localVarFp.apiAnalyticsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsModelsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ModelConfig>> {
            return localVarFp.apiAnalyticsModelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update One
         * @param {AnalyticsDto} analyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsPost(analyticsDto: AnalyticsDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsPost(analyticsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restart Task
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsRestartIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsRestartIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get List Of Stopped Tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsStopGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiAnalyticsStopGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stop Task
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsStopIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsStopIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsCtrlApi - object-oriented interface
 */
export class AnalyticsCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get All
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsGet(options?: RawAxiosRequestConfig) {
        return AnalyticsCtrlApiFp(this.configuration).apiAnalyticsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete One
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsCtrlApiFp(this.configuration).apiAnalyticsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get One
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsCtrlApiFp(this.configuration).apiAnalyticsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsModelsGet(options?: RawAxiosRequestConfig) {
        return AnalyticsCtrlApiFp(this.configuration).apiAnalyticsModelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update One
     * @param {AnalyticsDto} analyticsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsPost(analyticsDto: AnalyticsDto, options?: RawAxiosRequestConfig) {
        return AnalyticsCtrlApiFp(this.configuration).apiAnalyticsPost(analyticsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restart Task
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsRestartIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsCtrlApiFp(this.configuration).apiAnalyticsRestartIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get List Of Stopped Tasks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsStopGet(options?: RawAxiosRequestConfig) {
        return AnalyticsCtrlApiFp(this.configuration).apiAnalyticsStopGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stop Task
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsStopIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsCtrlApiFp(this.configuration).apiAnalyticsStopIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnalyticsEngineCtrlApi - axios parameter creator
 */
export const AnalyticsEngineCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Build Log
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsDetailBuildIdGet: async (buildId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesBuildsDetailBuildIdGet', 'buildId', buildId)
            const localVarPath = `/api/analytics/engines/builds/detail/{buildId}`
                .replace(`{${"buildId"}}`, encodeURIComponent(String(buildId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Build Log Text
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsDetailBuildIdLogsGet: async (buildId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesBuildsDetailBuildIdLogsGet', 'buildId', buildId)
            const localVarPath = `/api/analytics/engines/builds/detail/{buildId}/logs`
                .replace(`{${"buildId"}}`, encodeURIComponent(String(buildId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Build Logs
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsModelIdGet: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesBuildsModelIdGet', 'modelId', modelId)
            const localVarPath = `/api/analytics/engines/builds/{modelId}`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Latest Build Log
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsModelIdLatestGet: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesBuildsModelIdLatestGet', 'modelId', modelId)
            const localVarPath = `/api/analytics/engines/builds/{modelId}/latest`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Live Build Logs
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsModelIdLiveGet: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesBuildsModelIdLiveGet', 'modelId', modelId)
            const localVarPath = `/api/analytics/engines/builds/{modelId}/live`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Build Status
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsModelIdStatusGet: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesBuildsModelIdStatusGet', 'modelId', modelId)
            const localVarPath = `/api/analytics/engines/builds/{modelId}/status`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check All Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/engines/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check Health
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesHealthModelIdGet: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesHealthModelIdGet', 'modelId', modelId)
            const localVarPath = `/api/analytics/engines/health/{modelId}`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Undeploy
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesK8sModelIdDelete: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesK8sModelIdDelete', 'modelId', modelId)
            const localVarPath = `/api/analytics/engines/k8s/{modelId}`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deploy
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesK8sModelIdDeployPost: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesK8sModelIdDeployPost', 'modelId', modelId)
            const localVarPath = `/api/analytics/engines/k8s/{modelId}/deploy`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Scale
         * @param {string} modelId 
         * @param {ScaleRequest} scaleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesK8sModelIdScalePut: async (modelId: string, scaleRequest: ScaleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesK8sModelIdScalePut', 'modelId', modelId)
            // verify required parameter 'scaleRequest' is not null or undefined
            assertParamExists('apiAnalyticsEnginesK8sModelIdScalePut', 'scaleRequest', scaleRequest)
            const localVarPath = `/api/analytics/engines/k8s/{modelId}/scale`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scaleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Engine Status
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesK8sModelIdStatusGet: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesK8sModelIdStatusGet', 'modelId', modelId)
            const localVarPath = `/api/analytics/engines/k8s/{modelId}/status`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All Engine Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesK8sStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/engines/k8s/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Logs
         * @param {string} modelId 
         * @param {number} [tailLines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesLogsModelIdGet: async (modelId: string, tailLines?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesLogsModelIdGet', 'modelId', modelId)
            const localVarPath = `/api/analytics/engines/logs/{modelId}`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tailLines !== undefined) {
                localVarQueryParameter['tailLines'] = tailLines;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/engines/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Model
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsEnginesModelsIdDelete', 'id', id)
            const localVarPath = `/api/analytics/engines/models/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Model
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsEnginesModelsIdGet', 'id', id)
            const localVarPath = `/api/analytics/engines/models/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Model Version
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsIdVersionsVersionGet: async (id: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsEnginesModelsIdVersionsVersionGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiAnalyticsEnginesModelsIdVersionsVersionGet', 'version', version)
            const localVarPath = `/api/analytics/engines/models/{id}/versions/{version}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save Model
         * @param {ModelConfig} modelConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsPost: async (modelConfig: ModelConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelConfig' is not null or undefined
            assertParamExists('apiAnalyticsEnginesModelsPost', 'modelConfig', modelConfig)
            const localVarPath = `/api/analytics/engines/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modelConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save Model From Zip
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsUploadPost: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/engines/models/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Platform Files
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesPlatformLanguageGet: async (language: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('apiAnalyticsEnginesPlatformLanguageGet', 'language', language)
            const localVarPath = `/api/analytics/engines/platform/{language}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disconnect Connection
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqConnectionsNameDelete: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAnalyticsEnginesRabbitmqConnectionsNameDelete', 'name', name)
            const localVarPath = `/api/analytics/engines/rabbitmq/connections/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Rabbit Queues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqQueuesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/engines/rabbitmq/queues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Purge Queue
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqQueuesNameMessagesDelete: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAnalyticsEnginesRabbitmqQueuesNameMessagesDelete', 'name', name)
            const localVarPath = `/api/analytics/engines/rabbitmq/queues/{name}/messages`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Peek Queue Messages
         * @param {string} name 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqQueuesNamePeekGet: async (name: string, count?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAnalyticsEnginesRabbitmqQueuesNamePeekGet', 'name', name)
            const localVarPath = `/api/analytics/engines/rabbitmq/queues/{name}/peek`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Publish To Queue
         * @param {string} name 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqQueuesNamePublishPost: async (name: string, requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAnalyticsEnginesRabbitmqQueuesNamePublishPost', 'name', name)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('apiAnalyticsEnginesRabbitmqQueuesNamePublishPost', 'requestBody', requestBody)
            const localVarPath = `/api/analytics/engines/rabbitmq/queues/{name}/publish`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Worker Status
         * @param {string} engineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqWorkersEngineIdGet: async (engineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'engineId' is not null or undefined
            assertParamExists('apiAnalyticsEnginesRabbitmqWorkersEngineIdGet', 'engineId', engineId)
            const localVarPath = `/api/analytics/engines/rabbitmq/workers/{engineId}`
                .replace(`{${"engineId"}}`, encodeURIComponent(String(engineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All Worker Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqWorkersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/engines/rabbitmq/workers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsEngineCtrlApi - functional programming interface
 */
export const AnalyticsEngineCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsEngineCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Build Log
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesBuildsDetailBuildIdGet(buildId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesBuildsDetailBuildIdGet(buildId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesBuildsDetailBuildIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Build Log Text
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesBuildsDetailBuildIdLogsGet(buildId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesBuildsDetailBuildIdLogsGet(buildId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesBuildsDetailBuildIdLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Build Logs
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesBuildsModelIdGet(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesBuildsModelIdGet(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesBuildsModelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Latest Build Log
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesBuildsModelIdLatestGet(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesBuildsModelIdLatestGet(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesBuildsModelIdLatestGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Live Build Logs
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesBuildsModelIdLiveGet(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesBuildsModelIdLiveGet(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesBuildsModelIdLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Build Status
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesBuildsModelIdStatusGet(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesBuildsModelIdStatusGet(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesBuildsModelIdStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check All Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EngineHealth>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check Health
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesHealthModelIdGet(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EngineHealth>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesHealthModelIdGet(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesHealthModelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Undeploy
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesK8sModelIdDelete(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesK8sModelIdDelete(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesK8sModelIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deploy
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesK8sModelIdDeployPost(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesK8sModelIdDeployPost(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesK8sModelIdDeployPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Scale
         * @param {string} modelId 
         * @param {ScaleRequest} scaleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesK8sModelIdScalePut(modelId: string, scaleRequest: ScaleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesK8sModelIdScalePut(modelId, scaleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesK8sModelIdScalePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Engine Status
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesK8sModelIdStatusGet(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EngineStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesK8sModelIdStatusGet(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesK8sModelIdStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All Engine Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesK8sStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EngineStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesK8sStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesK8sStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Logs
         * @param {string} modelId 
         * @param {number} [tailLines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesLogsModelIdGet(modelId: string, tailLines?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PodLogs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesLogsModelIdGet(modelId, tailLines, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesLogsModelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesModelsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModelConfig>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesModelsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesModelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Model
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesModelsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesModelsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesModelsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Model
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesModelsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesModelsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesModelsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Model Version
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesModelsIdVersionsVersionGet(id: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesModelsIdVersionsVersionGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesModelsIdVersionsVersionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save Model
         * @param {ModelConfig} modelConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesModelsPost(modelConfig: ModelConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesModelsPost(modelConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesModelsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save Model From Zip
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesModelsUploadPost(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesModelsUploadPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesModelsUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Platform Files
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesPlatformLanguageGet(language: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesPlatformLanguageGet(language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesPlatformLanguageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disconnect Connection
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesRabbitmqConnectionsNameDelete(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesRabbitmqConnectionsNameDelete(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesRabbitmqConnectionsNameDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Rabbit Queues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesRabbitmqQueuesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RabbitQueueInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesRabbitmqQueuesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesRabbitmqQueuesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Purge Queue
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesRabbitmqQueuesNameMessagesDelete(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesRabbitmqQueuesNameMessagesDelete(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesRabbitmqQueuesNameMessagesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Peek Queue Messages
         * @param {string} name 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesRabbitmqQueuesNamePeekGet(name: string, count?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: any; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesRabbitmqQueuesNamePeekGet(name, count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesRabbitmqQueuesNamePeekGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Publish To Queue
         * @param {string} name 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesRabbitmqQueuesNamePublishPost(name: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesRabbitmqQueuesNamePublishPost(name, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesRabbitmqQueuesNamePublishPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Worker Status
         * @param {string} engineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesRabbitmqWorkersEngineIdGet(engineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesRabbitmqWorkersEngineIdGet(engineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesRabbitmqWorkersEngineIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All Worker Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesRabbitmqWorkersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkerStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesRabbitmqWorkersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsEngineCtrlApi.apiAnalyticsEnginesRabbitmqWorkersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalyticsEngineCtrlApi - factory interface
 */
export const AnalyticsEngineCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsEngineCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Build Log
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsDetailBuildIdGet(buildId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuildLog> {
            return localVarFp.apiAnalyticsEnginesBuildsDetailBuildIdGet(buildId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Build Log Text
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsDetailBuildIdLogsGet(buildId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiAnalyticsEnginesBuildsDetailBuildIdLogsGet(buildId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Build Logs
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsModelIdGet(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BuildLog>> {
            return localVarFp.apiAnalyticsEnginesBuildsModelIdGet(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Latest Build Log
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsModelIdLatestGet(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuildLog> {
            return localVarFp.apiAnalyticsEnginesBuildsModelIdLatestGet(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Live Build Logs
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsModelIdLiveGet(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiAnalyticsEnginesBuildsModelIdLiveGet(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Build Status
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesBuildsModelIdStatusGet(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsEnginesBuildsModelIdStatusGet(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check All Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<EngineHealth>> {
            return localVarFp.apiAnalyticsEnginesHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check Health
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesHealthModelIdGet(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<EngineHealth> {
            return localVarFp.apiAnalyticsEnginesHealthModelIdGet(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Undeploy
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesK8sModelIdDelete(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsEnginesK8sModelIdDelete(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deploy
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesK8sModelIdDeployPost(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsEnginesK8sModelIdDeployPost(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Scale
         * @param {string} modelId 
         * @param {ScaleRequest} scaleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesK8sModelIdScalePut(modelId: string, scaleRequest: ScaleRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsEnginesK8sModelIdScalePut(modelId, scaleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Engine Status
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesK8sModelIdStatusGet(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<EngineStatus> {
            return localVarFp.apiAnalyticsEnginesK8sModelIdStatusGet(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All Engine Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesK8sStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<EngineStatus>> {
            return localVarFp.apiAnalyticsEnginesK8sStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Logs
         * @param {string} modelId 
         * @param {number} [tailLines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesLogsModelIdGet(modelId: string, tailLines?: number, options?: RawAxiosRequestConfig): AxiosPromise<PodLogs> {
            return localVarFp.apiAnalyticsEnginesLogsModelIdGet(modelId, tailLines, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ModelConfig>> {
            return localVarFp.apiAnalyticsEnginesModelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Model
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsEnginesModelsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Model
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ModelConfig> {
            return localVarFp.apiAnalyticsEnginesModelsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Model Version
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsIdVersionsVersionGet(id: string, version: string, options?: RawAxiosRequestConfig): AxiosPromise<ModelConfig> {
            return localVarFp.apiAnalyticsEnginesModelsIdVersionsVersionGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save Model
         * @param {ModelConfig} modelConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsPost(modelConfig: ModelConfig, options?: RawAxiosRequestConfig): AxiosPromise<ModelConfig> {
            return localVarFp.apiAnalyticsEnginesModelsPost(modelConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save Model From Zip
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesModelsUploadPost(file?: File, options?: RawAxiosRequestConfig): AxiosPromise<ModelConfig> {
            return localVarFp.apiAnalyticsEnginesModelsUploadPost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Platform Files
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesPlatformLanguageGet(language: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiAnalyticsEnginesPlatformLanguageGet(language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disconnect Connection
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqConnectionsNameDelete(name: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsEnginesRabbitmqConnectionsNameDelete(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Rabbit Queues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqQueuesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<RabbitQueueInfo>> {
            return localVarFp.apiAnalyticsEnginesRabbitmqQueuesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Purge Queue
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqQueuesNameMessagesDelete(name: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsEnginesRabbitmqQueuesNameMessagesDelete(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Peek Queue Messages
         * @param {string} name 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqQueuesNamePeekGet(name: string, count?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: any; }>> {
            return localVarFp.apiAnalyticsEnginesRabbitmqQueuesNamePeekGet(name, count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Publish To Queue
         * @param {string} name 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqQueuesNamePublishPost(name: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsEnginesRabbitmqQueuesNamePublishPost(name, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Worker Status
         * @param {string} engineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqWorkersEngineIdGet(engineId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkerStatus> {
            return localVarFp.apiAnalyticsEnginesRabbitmqWorkersEngineIdGet(engineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All Worker Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesRabbitmqWorkersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkerStatus>> {
            return localVarFp.apiAnalyticsEnginesRabbitmqWorkersGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsEngineCtrlApi - object-oriented interface
 */
export class AnalyticsEngineCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get Build Log
     * @param {string} buildId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesBuildsDetailBuildIdGet(buildId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesBuildsDetailBuildIdGet(buildId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Build Log Text
     * @param {string} buildId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesBuildsDetailBuildIdLogsGet(buildId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesBuildsDetailBuildIdLogsGet(buildId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Build Logs
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesBuildsModelIdGet(modelId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesBuildsModelIdGet(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Latest Build Log
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesBuildsModelIdLatestGet(modelId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesBuildsModelIdLatestGet(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Live Build Logs
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesBuildsModelIdLiveGet(modelId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesBuildsModelIdLiveGet(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Build Status
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesBuildsModelIdStatusGet(modelId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesBuildsModelIdStatusGet(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check All Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesHealthGet(options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check Health
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesHealthModelIdGet(modelId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesHealthModelIdGet(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Undeploy
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesK8sModelIdDelete(modelId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesK8sModelIdDelete(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deploy
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesK8sModelIdDeployPost(modelId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesK8sModelIdDeployPost(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Scale
     * @param {string} modelId 
     * @param {ScaleRequest} scaleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesK8sModelIdScalePut(modelId: string, scaleRequest: ScaleRequest, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesK8sModelIdScalePut(modelId, scaleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Engine Status
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesK8sModelIdStatusGet(modelId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesK8sModelIdStatusGet(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All Engine Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesK8sStatusGet(options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesK8sStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Logs
     * @param {string} modelId 
     * @param {number} [tailLines] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesLogsModelIdGet(modelId: string, tailLines?: number, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesLogsModelIdGet(modelId, tailLines, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesModelsGet(options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesModelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Model
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesModelsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesModelsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Model
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesModelsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesModelsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Model Version
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesModelsIdVersionsVersionGet(id: string, version: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesModelsIdVersionsVersionGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save Model
     * @param {ModelConfig} modelConfig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesModelsPost(modelConfig: ModelConfig, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesModelsPost(modelConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save Model From Zip
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesModelsUploadPost(file?: File, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesModelsUploadPost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Platform Files
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesPlatformLanguageGet(language: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesPlatformLanguageGet(language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disconnect Connection
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesRabbitmqConnectionsNameDelete(name: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesRabbitmqConnectionsNameDelete(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Rabbit Queues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesRabbitmqQueuesGet(options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesRabbitmqQueuesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Purge Queue
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesRabbitmqQueuesNameMessagesDelete(name: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesRabbitmqQueuesNameMessagesDelete(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Peek Queue Messages
     * @param {string} name 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesRabbitmqQueuesNamePeekGet(name: string, count?: number, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesRabbitmqQueuesNamePeekGet(name, count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Publish To Queue
     * @param {string} name 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesRabbitmqQueuesNamePublishPost(name: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesRabbitmqQueuesNamePublishPost(name, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Worker Status
     * @param {string} engineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesRabbitmqWorkersEngineIdGet(engineId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesRabbitmqWorkersEngineIdGet(engineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All Worker Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesRabbitmqWorkersGet(options?: RawAxiosRequestConfig) {
        return AnalyticsEngineCtrlApiFp(this.configuration).apiAnalyticsEnginesRabbitmqWorkersGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnalyticsManagerCtrlApi - axios parameter creator
 */
export const AnalyticsManagerCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsManagerAddIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsManagerAddIdGet', 'id', id)
            const localVarPath = `/api/analytics/manager/add/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsManagerGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/manager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsManagerIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsManagerIdDelete', 'id', id)
            const localVarPath = `/api/analytics/manager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsManagerCtrlApi - functional programming interface
 */
export const AnalyticsManagerCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsManagerCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsManagerAddIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsManagerAddIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsManagerCtrlApi.apiAnalyticsManagerAddIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsManagerGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsManagerGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsManagerCtrlApi.apiAnalyticsManagerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsManagerIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsManagerIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsManagerCtrlApi.apiAnalyticsManagerIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalyticsManagerCtrlApi - factory interface
 */
export const AnalyticsManagerCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsManagerCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsManagerAddIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsManagerAddIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsManagerGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiAnalyticsManagerGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsManagerIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsManagerIdDelete(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsManagerCtrlApi - object-oriented interface
 */
export class AnalyticsManagerCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get One
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsManagerAddIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsManagerCtrlApiFp(this.configuration).apiAnalyticsManagerAddIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsManagerGet(options?: RawAxiosRequestConfig) {
        return AnalyticsManagerCtrlApiFp(this.configuration).apiAnalyticsManagerGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete One
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsManagerIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsManagerCtrlApiFp(this.configuration).apiAnalyticsManagerIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnalyticsTemplateCtrlApi - axios parameter creator
 */
export const AnalyticsTemplateCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/engines/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsEnginesTemplatesIdDelete', 'id', id)
            const localVarPath = `/api/analytics/engines/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsEnginesTemplatesIdGet', 'id', id)
            const localVarPath = `/api/analytics/engines/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Template
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesIdPut: async (id: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsEnginesTemplatesIdPut', 'id', id)
            const localVarPath = `/api/analytics/engines/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Template As Zip
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesIdZipGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAnalyticsEnginesTemplatesIdZipGet', 'id', id)
            const localVarPath = `/api/analytics/engines/templates/{id}/zip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/zip';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Template
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesPost: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/engines/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsTemplateCtrlApi - functional programming interface
 */
export const AnalyticsTemplateCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsTemplateCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesTemplatesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesTemplatesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTemplateCtrlApi.apiAnalyticsEnginesTemplatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesTemplatesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesTemplatesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTemplateCtrlApi.apiAnalyticsEnginesTemplatesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesTemplatesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LanguageTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesTemplatesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTemplateCtrlApi.apiAnalyticsEnginesTemplatesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Template
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesTemplatesIdPut(id: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LanguageTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesTemplatesIdPut(id, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTemplateCtrlApi.apiAnalyticsEnginesTemplatesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Template As Zip
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesTemplatesIdZipGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesTemplatesIdZipGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTemplateCtrlApi.apiAnalyticsEnginesTemplatesIdZipGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Template
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsEnginesTemplatesPost(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LanguageTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsEnginesTemplatesPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTemplateCtrlApi.apiAnalyticsEnginesTemplatesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalyticsTemplateCtrlApi - factory interface
 */
export const AnalyticsTemplateCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsTemplateCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<LanguageTemplate>> {
            return localVarFp.apiAnalyticsEnginesTemplatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsEnginesTemplatesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<LanguageTemplate> {
            return localVarFp.apiAnalyticsEnginesTemplatesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Template
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesIdPut(id: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<LanguageTemplate> {
            return localVarFp.apiAnalyticsEnginesTemplatesIdPut(id, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Template As Zip
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesIdZipGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAnalyticsEnginesTemplatesIdZipGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Template
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEnginesTemplatesPost(file?: File, options?: RawAxiosRequestConfig): AxiosPromise<LanguageTemplate> {
            return localVarFp.apiAnalyticsEnginesTemplatesPost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsTemplateCtrlApi - object-oriented interface
 */
export class AnalyticsTemplateCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get Templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesTemplatesGet(options?: RawAxiosRequestConfig) {
        return AnalyticsTemplateCtrlApiFp(this.configuration).apiAnalyticsEnginesTemplatesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Template
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesTemplatesIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsTemplateCtrlApiFp(this.configuration).apiAnalyticsEnginesTemplatesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Template
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesTemplatesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsTemplateCtrlApiFp(this.configuration).apiAnalyticsEnginesTemplatesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Template
     * @param {string} id 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesTemplatesIdPut(id: string, file?: File, options?: RawAxiosRequestConfig) {
        return AnalyticsTemplateCtrlApiFp(this.configuration).apiAnalyticsEnginesTemplatesIdPut(id, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Template As Zip
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesTemplatesIdZipGet(id: string, options?: RawAxiosRequestConfig) {
        return AnalyticsTemplateCtrlApiFp(this.configuration).apiAnalyticsEnginesTemplatesIdZipGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Template
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsEnginesTemplatesPost(file?: File, options?: RawAxiosRequestConfig) {
        return AnalyticsTemplateCtrlApiFp(this.configuration).apiAnalyticsEnginesTemplatesPost(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnalyticsTimingCtrlApi - axios parameter creator
 */
export const AnalyticsTimingCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdDelete: async (analyticsId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticsId' is not null or undefined
            assertParamExists('apiAnalyticsTimingAnalyticsIdDelete', 'analyticsId', analyticsId)
            const localVarPath = `/api/analytics/timing/{analyticsId}`
                .replace(`{${"analyticsId"}}`, encodeURIComponent(String(analyticsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdGet: async (analyticsId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticsId' is not null or undefined
            assertParamExists('apiAnalyticsTimingAnalyticsIdGet', 'analyticsId', analyticsId)
            const localVarPath = `/api/analytics/timing/{analyticsId}`
                .replace(`{${"analyticsId"}}`, encodeURIComponent(String(analyticsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Latest
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdLatestGet: async (analyticsId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticsId' is not null or undefined
            assertParamExists('apiAnalyticsTimingAnalyticsIdLatestGet', 'analyticsId', analyticsId)
            const localVarPath = `/api/analytics/timing/{analyticsId}/latest`
                .replace(`{${"analyticsId"}}`, encodeURIComponent(String(analyticsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdPost: async (analyticsId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticsId' is not null or undefined
            assertParamExists('apiAnalyticsTimingAnalyticsIdPost', 'analyticsId', analyticsId)
            const localVarPath = `/api/analytics/timing/{analyticsId}`
                .replace(`{${"analyticsId"}}`, encodeURIComponent(String(analyticsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Report
         * @param {string} analyticsId 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdReportGet: async (analyticsId: string, version?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticsId' is not null or undefined
            assertParamExists('apiAnalyticsTimingAnalyticsIdReportGet', 'analyticsId', analyticsId)
            const localVarPath = `/api/analytics/timing/{analyticsId}/report`
                .replace(`{${"analyticsId"}}`, encodeURIComponent(String(analyticsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add Step
         * @param {string} analyticsId 
         * @param {string} step 
         * @param {string} [model] 
         * @param {string} [podName] 
         * @param {string} [taskId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdStepStepPost: async (analyticsId: string, step: string, model?: string, podName?: string, taskId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticsId' is not null or undefined
            assertParamExists('apiAnalyticsTimingAnalyticsIdStepStepPost', 'analyticsId', analyticsId)
            // verify required parameter 'step' is not null or undefined
            assertParamExists('apiAnalyticsTimingAnalyticsIdStepStepPost', 'step', step)
            const localVarPath = `/api/analytics/timing/{analyticsId}/step/{step}`
                .replace(`{${"analyticsId"}}`, encodeURIComponent(String(analyticsId)))
                .replace(`{${"step"}}`, encodeURIComponent(String(step)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }

            if (podName !== undefined) {
                localVarQueryParameter['podName'] = podName;
            }

            if (taskId !== undefined) {
                localVarQueryParameter['taskId'] = taskId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get By Version
         * @param {string} analyticsId 
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdVersionVersionGet: async (analyticsId: string, version: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticsId' is not null or undefined
            assertParamExists('apiAnalyticsTimingAnalyticsIdVersionVersionGet', 'analyticsId', analyticsId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiAnalyticsTimingAnalyticsIdVersionVersionGet', 'version', version)
            const localVarPath = `/api/analytics/timing/{analyticsId}/version/{version}`
                .replace(`{${"analyticsId"}}`, encodeURIComponent(String(analyticsId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsTimingCtrlApi - functional programming interface
 */
export const AnalyticsTimingCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsTimingCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsTimingAnalyticsIdDelete(analyticsId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsTimingAnalyticsIdDelete(analyticsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTimingCtrlApi.apiAnalyticsTimingAnalyticsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsTimingAnalyticsIdGet(analyticsId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsTimingAnalyticsIdGet(analyticsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTimingCtrlApi.apiAnalyticsTimingAnalyticsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Latest
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsTimingAnalyticsIdLatestGet(analyticsId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsTimingAnalyticsIdLatestGet(analyticsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTimingCtrlApi.apiAnalyticsTimingAnalyticsIdLatestGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsTimingAnalyticsIdPost(analyticsId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsTimingAnalyticsIdPost(analyticsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTimingCtrlApi.apiAnalyticsTimingAnalyticsIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Report
         * @param {string} analyticsId 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsTimingAnalyticsIdReportGet(analyticsId: string, version?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsTimingAnalyticsIdReportGet(analyticsId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTimingCtrlApi.apiAnalyticsTimingAnalyticsIdReportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add Step
         * @param {string} analyticsId 
         * @param {string} step 
         * @param {string} [model] 
         * @param {string} [podName] 
         * @param {string} [taskId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsTimingAnalyticsIdStepStepPost(analyticsId: string, step: string, model?: string, podName?: string, taskId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsTimingAnalyticsIdStepStepPost(analyticsId, step, model, podName, taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTimingCtrlApi.apiAnalyticsTimingAnalyticsIdStepStepPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get By Version
         * @param {string} analyticsId 
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnalyticsTimingAnalyticsIdVersionVersionGet(analyticsId: string, version: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnalyticsTimingAnalyticsIdVersionVersionGet(analyticsId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsTimingCtrlApi.apiAnalyticsTimingAnalyticsIdVersionVersionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalyticsTimingCtrlApi - factory interface
 */
export const AnalyticsTimingCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsTimingCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdDelete(analyticsId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsTimingAnalyticsIdDelete(analyticsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdGet(analyticsId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsTimingAnalyticsIdGet(analyticsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Latest
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdLatestGet(analyticsId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsTimingAnalyticsIdLatestGet(analyticsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create
         * @param {string} analyticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdPost(analyticsId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsTimingAnalyticsIdPost(analyticsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Report
         * @param {string} analyticsId 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdReportGet(analyticsId: string, version?: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsTimingAnalyticsIdReportGet(analyticsId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add Step
         * @param {string} analyticsId 
         * @param {string} step 
         * @param {string} [model] 
         * @param {string} [podName] 
         * @param {string} [taskId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdStepStepPost(analyticsId: string, step: string, model?: string, podName?: string, taskId?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsTimingAnalyticsIdStepStepPost(analyticsId, step, model, podName, taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get By Version
         * @param {string} analyticsId 
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsTimingAnalyticsIdVersionVersionGet(analyticsId: string, version: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAnalyticsTimingAnalyticsIdVersionVersionGet(analyticsId, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsTimingCtrlApi - object-oriented interface
 */
export class AnalyticsTimingCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Delete
     * @param {string} analyticsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsTimingAnalyticsIdDelete(analyticsId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsTimingCtrlApiFp(this.configuration).apiAnalyticsTimingAnalyticsIdDelete(analyticsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All
     * @param {string} analyticsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsTimingAnalyticsIdGet(analyticsId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsTimingCtrlApiFp(this.configuration).apiAnalyticsTimingAnalyticsIdGet(analyticsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Latest
     * @param {string} analyticsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsTimingAnalyticsIdLatestGet(analyticsId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsTimingCtrlApiFp(this.configuration).apiAnalyticsTimingAnalyticsIdLatestGet(analyticsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create
     * @param {string} analyticsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsTimingAnalyticsIdPost(analyticsId: string, options?: RawAxiosRequestConfig) {
        return AnalyticsTimingCtrlApiFp(this.configuration).apiAnalyticsTimingAnalyticsIdPost(analyticsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Report
     * @param {string} analyticsId 
     * @param {number} [version] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsTimingAnalyticsIdReportGet(analyticsId: string, version?: number, options?: RawAxiosRequestConfig) {
        return AnalyticsTimingCtrlApiFp(this.configuration).apiAnalyticsTimingAnalyticsIdReportGet(analyticsId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add Step
     * @param {string} analyticsId 
     * @param {string} step 
     * @param {string} [model] 
     * @param {string} [podName] 
     * @param {string} [taskId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsTimingAnalyticsIdStepStepPost(analyticsId: string, step: string, model?: string, podName?: string, taskId?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsTimingCtrlApiFp(this.configuration).apiAnalyticsTimingAnalyticsIdStepStepPost(analyticsId, step, model, podName, taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get By Version
     * @param {string} analyticsId 
     * @param {number} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAnalyticsTimingAnalyticsIdVersionVersionGet(analyticsId: string, version: number, options?: RawAxiosRequestConfig) {
        return AnalyticsTimingCtrlApiFp(this.configuration).apiAnalyticsTimingAnalyticsIdVersionVersionGet(analyticsId, version, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthAdminCtrlManagementCtrlApi - axios parameter creator
 */
export const AuthAdminCtrlManagementCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create User
         * @param {PromiseUser} promiseUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminCreatePost: async (promiseUser: PromiseUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promiseUser' is not null or undefined
            assertParamExists('apiAuthAdminCreatePost', 'promiseUser', promiseUser)
            const localVarPath = `/api/auth/admin/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promiseUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete User
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminDelete: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List All Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Distinct Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminGroupsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/admin/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Distinct Institutions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminInstitutionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/admin/institutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Pending Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminPendingGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/admin/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke User Tokens
         * @param {string} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminRevokeTokensPost: async (login?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/admin/revoke-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (login !== undefined) {
                localVarQueryParameter['login'] = login;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update User
         * @param {PromiseUser} promiseUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminUpdatePut: async (promiseUser: PromiseUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promiseUser' is not null or undefined
            assertParamExists('apiAuthAdminUpdatePut', 'promiseUser', promiseUser)
            const localVarPath = `/api/auth/admin/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promiseUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate User
         * @param {ValidateUserDto} validateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminValidatePost: async (validateUserDto: ValidateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateUserDto' is not null or undefined
            assertParamExists('apiAuthAdminValidatePost', 'validateUserDto', validateUserDto)
            const localVarPath = `/api/auth/admin/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthAdminCtrlManagementCtrlApi - functional programming interface
 */
export const AuthAdminCtrlManagementCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthAdminCtrlManagementCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create User
         * @param {PromiseUser} promiseUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAdminCreatePost(promiseUser: PromiseUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAdminCreatePost(promiseUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthAdminCtrlManagementCtrlApi.apiAuthAdminCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete User
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAdminDelete(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAdminDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthAdminCtrlManagementCtrlApi.apiAuthAdminDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List All Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAdminGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromiseUser>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAdminGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthAdminCtrlManagementCtrlApi.apiAuthAdminGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Distinct Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAdminGroupsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAdminGroupsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthAdminCtrlManagementCtrlApi.apiAuthAdminGroupsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Distinct Institutions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAdminInstitutionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAdminInstitutionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthAdminCtrlManagementCtrlApi.apiAuthAdminInstitutionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Pending Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAdminPendingGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromiseUser>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAdminPendingGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthAdminCtrlManagementCtrlApi.apiAuthAdminPendingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke User Tokens
         * @param {string} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAdminRevokeTokensPost(login?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAdminRevokeTokensPost(login, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthAdminCtrlManagementCtrlApi.apiAuthAdminRevokeTokensPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update User
         * @param {PromiseUser} promiseUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAdminUpdatePut(promiseUser: PromiseUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAdminUpdatePut(promiseUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthAdminCtrlManagementCtrlApi.apiAuthAdminUpdatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate User
         * @param {ValidateUserDto} validateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAdminValidatePost(validateUserDto: ValidateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAdminValidatePost(validateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthAdminCtrlManagementCtrlApi.apiAuthAdminValidatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthAdminCtrlManagementCtrlApi - factory interface
 */
export const AuthAdminCtrlManagementCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthAdminCtrlManagementCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Create User
         * @param {PromiseUser} promiseUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminCreatePost(promiseUser: PromiseUser, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAuthAdminCreatePost(promiseUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete User
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminDelete(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAuthAdminDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List All Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<PromiseUser>> {
            return localVarFp.apiAuthAdminGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Distinct Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminGroupsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiAuthAdminGroupsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Distinct Institutions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminInstitutionsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiAuthAdminInstitutionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Pending Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminPendingGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<PromiseUser>> {
            return localVarFp.apiAuthAdminPendingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke User Tokens
         * @param {string} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminRevokeTokensPost(login?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAuthAdminRevokeTokensPost(login, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update User
         * @param {PromiseUser} promiseUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminUpdatePut(promiseUser: PromiseUser, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAuthAdminUpdatePut(promiseUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate User
         * @param {ValidateUserDto} validateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAdminValidatePost(validateUserDto: ValidateUserDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAuthAdminValidatePost(validateUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthAdminCtrlManagementCtrlApi - object-oriented interface
 */
export class AuthAdminCtrlManagementCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Create User
     * @param {PromiseUser} promiseUser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAdminCreatePost(promiseUser: PromiseUser, options?: RawAxiosRequestConfig) {
        return AuthAdminCtrlManagementCtrlApiFp(this.configuration).apiAuthAdminCreatePost(promiseUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete User
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAdminDelete(id?: string, options?: RawAxiosRequestConfig) {
        return AuthAdminCtrlManagementCtrlApiFp(this.configuration).apiAuthAdminDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List All Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAdminGet(options?: RawAxiosRequestConfig) {
        return AuthAdminCtrlManagementCtrlApiFp(this.configuration).apiAuthAdminGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Distinct Groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAdminGroupsGet(options?: RawAxiosRequestConfig) {
        return AuthAdminCtrlManagementCtrlApiFp(this.configuration).apiAuthAdminGroupsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Distinct Institutions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAdminInstitutionsGet(options?: RawAxiosRequestConfig) {
        return AuthAdminCtrlManagementCtrlApiFp(this.configuration).apiAuthAdminInstitutionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Pending Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAdminPendingGet(options?: RawAxiosRequestConfig) {
        return AuthAdminCtrlManagementCtrlApiFp(this.configuration).apiAuthAdminPendingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke User Tokens
     * @param {string} [login] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAdminRevokeTokensPost(login?: string, options?: RawAxiosRequestConfig) {
        return AuthAdminCtrlManagementCtrlApiFp(this.configuration).apiAuthAdminRevokeTokensPost(login, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update User
     * @param {PromiseUser} promiseUser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAdminUpdatePut(promiseUser: PromiseUser, options?: RawAxiosRequestConfig) {
        return AuthAdminCtrlManagementCtrlApiFp(this.configuration).apiAuthAdminUpdatePut(promiseUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate User
     * @param {ValidateUserDto} validateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAdminValidatePost(validateUserDto: ValidateUserDto, options?: RawAxiosRequestConfig) {
        return AuthAdminCtrlManagementCtrlApiFp(this.configuration).apiAuthAdminValidatePost(validateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthLoginCtrlApi - axios parameter creator
 */
export const AuthLoginCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Data
         * @param {string} instance 
         * @param {string} [grantType] 
         * @param {string} [username] 
         * @param {string} [password] 
         * @param {string} [refreshToken] 
         * @param {string} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthInstanceLoginPost: async (instance: string, grantType?: string, username?: string, password?: string, refreshToken?: string, accessToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiAuthInstanceLoginPost', 'instance', instance)
            const localVarPath = `/api/auth/{instance}/login`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (grantType !== undefined) { 
                localVarFormParams.set('grant_type', grantType as any);
            }

            if (username !== undefined) { 
                localVarFormParams.set('username', username as any);
            }

            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }

            if (refreshToken !== undefined) { 
                localVarFormParams.set('refresh_token', refreshToken as any);
            }

            if (accessToken !== undefined) { 
                localVarFormParams.set('access_token', accessToken as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Info
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthInstanceMeGet: async (instance: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiAuthInstanceMeGet', 'instance', instance)
            const localVarPath = `/api/auth/{instance}/me`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get List Users
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthInstanceUsersGet: async (instance: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiAuthInstanceUsersGet', 'instance', instance)
            const localVarPath = `/api/auth/{instance}/users`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthLoginCtrlApi - functional programming interface
 */
export const AuthLoginCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthLoginCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Data
         * @param {string} instance 
         * @param {string} [grantType] 
         * @param {string} [username] 
         * @param {string} [password] 
         * @param {string} [refreshToken] 
         * @param {string} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthInstanceLoginPost(instance: string, grantType?: string, username?: string, password?: string, refreshToken?: string, accessToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromiseOpenId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthInstanceLoginPost(instance, grantType, username, password, refreshToken, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthLoginCtrlApi.apiAuthInstanceLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Info
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthInstanceMeGet(instance: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromiseUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthInstanceMeGet(instance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthLoginCtrlApi.apiAuthInstanceMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get List Users
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthInstanceUsersGet(instance: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromiseUserShort>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthInstanceUsersGet(instance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthLoginCtrlApi.apiAuthInstanceUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthLoginCtrlApi - factory interface
 */
export const AuthLoginCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthLoginCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Data
         * @param {string} instance 
         * @param {string} [grantType] 
         * @param {string} [username] 
         * @param {string} [password] 
         * @param {string} [refreshToken] 
         * @param {string} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthInstanceLoginPost(instance: string, grantType?: string, username?: string, password?: string, refreshToken?: string, accessToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<PromiseOpenId> {
            return localVarFp.apiAuthInstanceLoginPost(instance, grantType, username, password, refreshToken, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Info
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthInstanceMeGet(instance: string, options?: RawAxiosRequestConfig): AxiosPromise<PromiseUser> {
            return localVarFp.apiAuthInstanceMeGet(instance, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get List Users
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthInstanceUsersGet(instance: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromiseUserShort>> {
            return localVarFp.apiAuthInstanceUsersGet(instance, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthLoginCtrlApi - object-oriented interface
 */
export class AuthLoginCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get Data
     * @param {string} instance 
     * @param {string} [grantType] 
     * @param {string} [username] 
     * @param {string} [password] 
     * @param {string} [refreshToken] 
     * @param {string} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthInstanceLoginPost(instance: string, grantType?: string, username?: string, password?: string, refreshToken?: string, accessToken?: string, options?: RawAxiosRequestConfig) {
        return AuthLoginCtrlApiFp(this.configuration).apiAuthInstanceLoginPost(instance, grantType, username, password, refreshToken, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Info
     * @param {string} instance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthInstanceMeGet(instance: string, options?: RawAxiosRequestConfig) {
        return AuthLoginCtrlApiFp(this.configuration).apiAuthInstanceMeGet(instance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get List Users
     * @param {string} instance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthInstanceUsersGet(instance: string, options?: RawAxiosRequestConfig) {
        return AuthLoginCtrlApiFp(this.configuration).apiAuthInstanceUsersGet(instance, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthManagementCtrlApi - axios parameter creator
 */
export const AuthManagementCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create User
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthManagementCreatePost: async (userDto: UserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDto' is not null or undefined
            assertParamExists('apiAuthManagementCreatePost', 'userDto', userDto)
            const localVarPath = `/api/auth/management/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset Password
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthManagementResetGet: async (email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/management/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Password
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthManagementUpdatePasswordPost: async (updatePasswordDto: UpdatePasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePasswordDto' is not null or undefined
            assertParamExists('apiAuthManagementUpdatePasswordPost', 'updatePasswordDto', updatePasswordDto)
            const localVarPath = `/api/auth/management/update-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Profile
         * @param {UpdateProfileDto} updateProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthManagementUpdateProfilePut: async (updateProfileDto: UpdateProfileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProfileDto' is not null or undefined
            assertParamExists('apiAuthManagementUpdateProfilePut', 'updateProfileDto', updateProfileDto)
            const localVarPath = `/api/auth/management/update-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthManagementCtrlApi - functional programming interface
 */
export const AuthManagementCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthManagementCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create User
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthManagementCreatePost(userDto: UserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthManagementCreatePost(userDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthManagementCtrlApi.apiAuthManagementCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset Password
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthManagementResetGet(email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthManagementResetGet(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthManagementCtrlApi.apiAuthManagementResetGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Password
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthManagementUpdatePasswordPost(updatePasswordDto: UpdatePasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthManagementUpdatePasswordPost(updatePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthManagementCtrlApi.apiAuthManagementUpdatePasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Profile
         * @param {UpdateProfileDto} updateProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthManagementUpdateProfilePut(updateProfileDto: UpdateProfileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthManagementUpdateProfilePut(updateProfileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthManagementCtrlApi.apiAuthManagementUpdateProfilePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthManagementCtrlApi - factory interface
 */
export const AuthManagementCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthManagementCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Create User
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthManagementCreatePost(userDto: UserDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAuthManagementCreatePost(userDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset Password
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthManagementResetGet(email?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAuthManagementResetGet(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Password
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthManagementUpdatePasswordPost(updatePasswordDto: UpdatePasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAuthManagementUpdatePasswordPost(updatePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Profile
         * @param {UpdateProfileDto} updateProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthManagementUpdateProfilePut(updateProfileDto: UpdateProfileDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAuthManagementUpdateProfilePut(updateProfileDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthManagementCtrlApi - object-oriented interface
 */
export class AuthManagementCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Create User
     * @param {UserDto} userDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthManagementCreatePost(userDto: UserDto, options?: RawAxiosRequestConfig) {
        return AuthManagementCtrlApiFp(this.configuration).apiAuthManagementCreatePost(userDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset Password
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthManagementResetGet(email?: string, options?: RawAxiosRequestConfig) {
        return AuthManagementCtrlApiFp(this.configuration).apiAuthManagementResetGet(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Password
     * @param {UpdatePasswordDto} updatePasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthManagementUpdatePasswordPost(updatePasswordDto: UpdatePasswordDto, options?: RawAxiosRequestConfig) {
        return AuthManagementCtrlApiFp(this.configuration).apiAuthManagementUpdatePasswordPost(updatePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Profile
     * @param {UpdateProfileDto} updateProfileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthManagementUpdateProfilePut(updateProfileDto: UpdateProfileDto, options?: RawAxiosRequestConfig) {
        return AuthManagementCtrlApiFp(this.configuration).apiAuthManagementUpdateProfilePut(updateProfileDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CmsManagerCtrlApi - axios parameter creator
 */
export const CmsManagerCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCmsIdGet', 'id', id)
            const localVarPath = `/api/cms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Trad
         * @param {string} id 
         * @param {string} lng 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsIdLngTranslationsJsonGet: async (id: string, lng: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCmsIdLngTranslationsJsonGet', 'id', id)
            // verify required parameter 'lng' is not null or undefined
            assertParamExists('apiCmsIdLngTranslationsJsonGet', 'lng', lng)
            const localVarPath = `/api/cms/{id}/{lng}/translations.json`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lng"}}`, encodeURIComponent(String(lng)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update One
         * @param {string} id 
         * @param {CmsViewDto} cmsViewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsIdPost: async (id: string, cmsViewDto: CmsViewDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCmsIdPost', 'id', id)
            // verify required parameter 'cmsViewDto' is not null or undefined
            assertParamExists('apiCmsIdPost', 'cmsViewDto', cmsViewDto)
            const localVarPath = `/api/cms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cmsViewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Image
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsImagesFilenameGet: async (filename: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('apiCmsImagesFilenameGet', 'filename', filename)
            const localVarPath = `/api/cms/images/{filename}`
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Image
         * @param {File} [file] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsImagesPost: async (file?: File, fileName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cms/images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (fileName !== undefined) { 
                localVarFormParams.append('fileName', fileName as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCmsNotificationsIdDelete', 'id', id)
            const localVarPath = `/api/cms/notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Notification Status
         * @param {string} id 
         * @param {NotificationDto} notificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsIdStatusPost: async (id: string, notificationDto: NotificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCmsNotificationsIdStatusPost', 'id', id)
            // verify required parameter 'notificationDto' is not null or undefined
            assertParamExists('apiCmsNotificationsIdStatusPost', 'notificationDto', notificationDto)
            const localVarPath = `/api/cms/notifications/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsListGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cms/notifications/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Push Subscribe
         * @param {WebPushSubscriptionDto} webPushSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsPushSubscribePost: async (webPushSubscriptionDto: WebPushSubscriptionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webPushSubscriptionDto' is not null or undefined
            assertParamExists('apiCmsNotificationsPushSubscribePost', 'webPushSubscriptionDto', webPushSubscriptionDto)
            const localVarPath = `/api/cms/notifications/push/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webPushSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Push Test
         * @param {string} [admin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsPushTestPost: async (admin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cms/notifications/push/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (admin !== undefined) {
                localVarQueryParameter['admin'] = admin;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Push Unsubscribe
         * @param {WebPushSubscriptionDto} webPushSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsPushUnsubscribePost: async (webPushSubscriptionDto: WebPushSubscriptionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webPushSubscriptionDto' is not null or undefined
            assertParamExists('apiCmsNotificationsPushUnsubscribePost', 'webPushSubscriptionDto', webPushSubscriptionDto)
            const localVarPath = `/api/cms/notifications/push/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webPushSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Subscription
         * @param {string} [admin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsSubscriptionGet: async (admin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cms/notifications/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (admin !== undefined) {
                localVarQueryParameter['admin'] = admin;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save Subscription
         * @param {NotificationSubscriptionDto} notificationSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsSubscriptionPut: async (notificationSubscriptionDto: NotificationSubscriptionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationSubscriptionDto' is not null or undefined
            assertParamExists('apiCmsNotificationsSubscriptionPut', 'notificationSubscriptionDto', notificationSubscriptionDto)
            const localVarPath = `/api/cms/notifications/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark Seen
         * @param {string} [admin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsSubscriptionSeenPost: async (admin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cms/notifications/subscription/seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (admin !== undefined) {
                localVarQueryParameter['admin'] = admin;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CmsManagerCtrlApi - functional programming interface
 */
export const CmsManagerCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CmsManagerCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CmsViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Trad
         * @param {string} id 
         * @param {string} lng 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsIdLngTranslationsJsonGet(id: string, lng: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsIdLngTranslationsJsonGet(id, lng, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsIdLngTranslationsJsonGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update One
         * @param {string} id 
         * @param {CmsViewDto} cmsViewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsIdPost(id: string, cmsViewDto: CmsViewDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsIdPost(id, cmsViewDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Image
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsImagesFilenameGet(filename: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsImagesFilenameGet(filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsImagesFilenameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Image
         * @param {File} [file] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsImagesPost(file?: File, fileName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsImagesPost(file, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsImagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsNotificationsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsNotificationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsNotificationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Notification Status
         * @param {string} id 
         * @param {NotificationDto} notificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsNotificationsIdStatusPost(id: string, notificationDto: NotificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsNotificationsIdStatusPost(id, notificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsNotificationsIdStatusPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsNotificationsListGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsNotificationsListGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsNotificationsListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Push Subscribe
         * @param {WebPushSubscriptionDto} webPushSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsNotificationsPushSubscribePost(webPushSubscriptionDto: WebPushSubscriptionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsNotificationsPushSubscribePost(webPushSubscriptionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsNotificationsPushSubscribePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Push Test
         * @param {string} [admin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsNotificationsPushTestPost(admin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsNotificationsPushTestPost(admin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsNotificationsPushTestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Push Unsubscribe
         * @param {WebPushSubscriptionDto} webPushSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsNotificationsPushUnsubscribePost(webPushSubscriptionDto: WebPushSubscriptionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsNotificationsPushUnsubscribePost(webPushSubscriptionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsNotificationsPushUnsubscribePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Subscription
         * @param {string} [admin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsNotificationsSubscriptionGet(admin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsNotificationsSubscriptionGet(admin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsNotificationsSubscriptionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save Subscription
         * @param {NotificationSubscriptionDto} notificationSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsNotificationsSubscriptionPut(notificationSubscriptionDto: NotificationSubscriptionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsNotificationsSubscriptionPut(notificationSubscriptionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsNotificationsSubscriptionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark Seen
         * @param {string} [admin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCmsNotificationsSubscriptionSeenPost(admin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCmsNotificationsSubscriptionSeenPost(admin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsManagerCtrlApi.apiCmsNotificationsSubscriptionSeenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CmsManagerCtrlApi - factory interface
 */
export const CmsManagerCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CmsManagerCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CmsViewDto> {
            return localVarFp.apiCmsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Trad
         * @param {string} id 
         * @param {string} lng 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsIdLngTranslationsJsonGet(id: string, lng: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.apiCmsIdLngTranslationsJsonGet(id, lng, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update One
         * @param {string} id 
         * @param {CmsViewDto} cmsViewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsIdPost(id: string, cmsViewDto: CmsViewDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCmsIdPost(id, cmsViewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Image
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsImagesFilenameGet(filename: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCmsImagesFilenameGet(filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Image
         * @param {File} [file] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsImagesPost(file?: File, fileName?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCmsImagesPost(file, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCmsNotificationsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Notification Status
         * @param {string} id 
         * @param {NotificationDto} notificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsIdStatusPost(id: string, notificationDto: NotificationDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCmsNotificationsIdStatusPost(id, notificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsListGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationDto>> {
            return localVarFp.apiCmsNotificationsListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Push Subscribe
         * @param {WebPushSubscriptionDto} webPushSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsPushSubscribePost(webPushSubscriptionDto: WebPushSubscriptionDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCmsNotificationsPushSubscribePost(webPushSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Push Test
         * @param {string} [admin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsPushTestPost(admin?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCmsNotificationsPushTestPost(admin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Push Unsubscribe
         * @param {WebPushSubscriptionDto} webPushSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsPushUnsubscribePost(webPushSubscriptionDto: WebPushSubscriptionDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCmsNotificationsPushUnsubscribePost(webPushSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Subscription
         * @param {string} [admin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsSubscriptionGet(admin?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationSubscriptionDto> {
            return localVarFp.apiCmsNotificationsSubscriptionGet(admin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save Subscription
         * @param {NotificationSubscriptionDto} notificationSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsSubscriptionPut(notificationSubscriptionDto: NotificationSubscriptionDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCmsNotificationsSubscriptionPut(notificationSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark Seen
         * @param {string} [admin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCmsNotificationsSubscriptionSeenPost(admin?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiCmsNotificationsSubscriptionSeenPost(admin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CmsManagerCtrlApi - object-oriented interface
 */
export class CmsManagerCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get One
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Trad
     * @param {string} id 
     * @param {string} lng 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsIdLngTranslationsJsonGet(id: string, lng: string, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsIdLngTranslationsJsonGet(id, lng, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update One
     * @param {string} id 
     * @param {CmsViewDto} cmsViewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsIdPost(id: string, cmsViewDto: CmsViewDto, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsIdPost(id, cmsViewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Image
     * @param {string} filename 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsImagesFilenameGet(filename: string, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsImagesFilenameGet(filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Image
     * @param {File} [file] 
     * @param {string} [fileName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsImagesPost(file?: File, fileName?: string, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsImagesPost(file, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Notification
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsNotificationsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsNotificationsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Notification Status
     * @param {string} id 
     * @param {NotificationDto} notificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsNotificationsIdStatusPost(id: string, notificationDto: NotificationDto, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsNotificationsIdStatusPost(id, notificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsNotificationsListGet(options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsNotificationsListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Push Subscribe
     * @param {WebPushSubscriptionDto} webPushSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsNotificationsPushSubscribePost(webPushSubscriptionDto: WebPushSubscriptionDto, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsNotificationsPushSubscribePost(webPushSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Push Test
     * @param {string} [admin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsNotificationsPushTestPost(admin?: string, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsNotificationsPushTestPost(admin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Push Unsubscribe
     * @param {WebPushSubscriptionDto} webPushSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsNotificationsPushUnsubscribePost(webPushSubscriptionDto: WebPushSubscriptionDto, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsNotificationsPushUnsubscribePost(webPushSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Subscription
     * @param {string} [admin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsNotificationsSubscriptionGet(admin?: string, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsNotificationsSubscriptionGet(admin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save Subscription
     * @param {NotificationSubscriptionDto} notificationSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsNotificationsSubscriptionPut(notificationSubscriptionDto: NotificationSubscriptionDto, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsNotificationsSubscriptionPut(notificationSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark Seen
     * @param {string} [admin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCmsNotificationsSubscriptionSeenPost(admin?: string, options?: RawAxiosRequestConfig) {
        return CmsManagerCtrlApiFp(this.configuration).apiCmsNotificationsSubscriptionSeenPost(admin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ColumnProfileCtrlApi - axios parameter creator
 */
export const ColumnProfileCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Save All
         * @param {Array<ColumnProfile>} columnProfile 
         * @param {string} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesBulkPost: async (columnProfile: Array<ColumnProfile>, mode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnProfile' is not null or undefined
            assertParamExists('apiAdminColumnProfilesBulkPost', 'columnProfile', columnProfile)
            const localVarPath = `/api/admin/column-profiles/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(columnProfile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesExportGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/column-profiles/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/column-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesNameDelete: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAdminColumnProfilesNameDelete', 'name', name)
            const localVarPath = `/api/admin/column-profiles/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get By Column
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesNameGet: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAdminColumnProfilesNameGet', 'name', name)
            const localVarPath = `/api/admin/column-profiles/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save
         * @param {string} name 
         * @param {ColumnProfile} columnProfile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesNamePut: async (name: string, columnProfile: ColumnProfile, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAdminColumnProfilesNamePut', 'name', name)
            // verify required parameter 'columnProfile' is not null or undefined
            assertParamExists('apiAdminColumnProfilesNamePut', 'columnProfile', columnProfile)
            const localVarPath = `/api/admin/column-profiles/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(columnProfile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ColumnProfileCtrlApi - functional programming interface
 */
export const ColumnProfileCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ColumnProfileCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Save All
         * @param {Array<ColumnProfile>} columnProfile 
         * @param {string} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminColumnProfilesBulkPost(columnProfile: Array<ColumnProfile>, mode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminColumnProfilesBulkPost(columnProfile, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColumnProfileCtrlApi.apiAdminColumnProfilesBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminColumnProfilesExportGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ColumnProfile>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminColumnProfilesExportGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColumnProfileCtrlApi.apiAdminColumnProfilesExportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminColumnProfilesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ColumnProfile>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminColumnProfilesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColumnProfileCtrlApi.apiAdminColumnProfilesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminColumnProfilesNameDelete(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminColumnProfilesNameDelete(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColumnProfileCtrlApi.apiAdminColumnProfilesNameDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get By Column
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminColumnProfilesNameGet(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminColumnProfilesNameGet(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColumnProfileCtrlApi.apiAdminColumnProfilesNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save
         * @param {string} name 
         * @param {ColumnProfile} columnProfile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminColumnProfilesNamePut(name: string, columnProfile: ColumnProfile, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminColumnProfilesNamePut(name, columnProfile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColumnProfileCtrlApi.apiAdminColumnProfilesNamePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ColumnProfileCtrlApi - factory interface
 */
export const ColumnProfileCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ColumnProfileCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Save All
         * @param {Array<ColumnProfile>} columnProfile 
         * @param {string} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesBulkPost(columnProfile: Array<ColumnProfile>, mode?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.apiAdminColumnProfilesBulkPost(columnProfile, mode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesExportGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ColumnProfile>> {
            return localVarFp.apiAdminColumnProfilesExportGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ColumnProfile>> {
            return localVarFp.apiAdminColumnProfilesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesNameDelete(name: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAdminColumnProfilesNameDelete(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get By Column
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesNameGet(name: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAdminColumnProfilesNameGet(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save
         * @param {string} name 
         * @param {ColumnProfile} columnProfile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminColumnProfilesNamePut(name: string, columnProfile: ColumnProfile, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAdminColumnProfilesNamePut(name, columnProfile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ColumnProfileCtrlApi - object-oriented interface
 */
export class ColumnProfileCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Save All
     * @param {Array<ColumnProfile>} columnProfile 
     * @param {string} [mode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminColumnProfilesBulkPost(columnProfile: Array<ColumnProfile>, mode?: string, options?: RawAxiosRequestConfig) {
        return ColumnProfileCtrlApiFp(this.configuration).apiAdminColumnProfilesBulkPost(columnProfile, mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export All
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminColumnProfilesExportGet(options?: RawAxiosRequestConfig) {
        return ColumnProfileCtrlApiFp(this.configuration).apiAdminColumnProfilesExportGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminColumnProfilesGet(options?: RawAxiosRequestConfig) {
        return ColumnProfileCtrlApiFp(this.configuration).apiAdminColumnProfilesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminColumnProfilesNameDelete(name: string, options?: RawAxiosRequestConfig) {
        return ColumnProfileCtrlApiFp(this.configuration).apiAdminColumnProfilesNameDelete(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get By Column
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminColumnProfilesNameGet(name: string, options?: RawAxiosRequestConfig) {
        return ColumnProfileCtrlApiFp(this.configuration).apiAdminColumnProfilesNameGet(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save
     * @param {string} name 
     * @param {ColumnProfile} columnProfile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminColumnProfilesNamePut(name: string, columnProfile: ColumnProfile, options?: RawAxiosRequestConfig) {
        return ColumnProfileCtrlApiFp(this.configuration).apiAdminColumnProfilesNamePut(name, columnProfile, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConceptCtrlApi - axios parameter creator
 */
export const ConceptCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Save All
         * @param {Array<Concept>} concept 
         * @param {string} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsBulkPost: async (concept: Array<Concept>, mode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'concept' is not null or undefined
            assertParamExists('apiAdminConceptsBulkPost', 'concept', concept)
            const localVarPath = `/api/admin/concepts/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(concept, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsExportGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/concepts/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsGet: async (type?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/concepts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAdminConceptsIdDelete', 'id', id)
            const localVarPath = `/api/admin/concepts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get By Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAdminConceptsIdGet', 'id', id)
            const localVarPath = `/api/admin/concepts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save
         * @param {string} id 
         * @param {Concept} concept 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsIdPut: async (id: string, concept: Concept, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAdminConceptsIdPut', 'id', id)
            // verify required parameter 'concept' is not null or undefined
            assertParamExists('apiAdminConceptsIdPut', 'concept', concept)
            const localVarPath = `/api/admin/concepts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(concept, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsReloadPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/concepts/reload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConceptCtrlApi - functional programming interface
 */
export const ConceptCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConceptCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Save All
         * @param {Array<Concept>} concept 
         * @param {string} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminConceptsBulkPost(concept: Array<Concept>, mode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminConceptsBulkPost(concept, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConceptCtrlApi.apiAdminConceptsBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminConceptsExportGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Concept>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminConceptsExportGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConceptCtrlApi.apiAdminConceptsExportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminConceptsGet(type?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Concept>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminConceptsGet(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConceptCtrlApi.apiAdminConceptsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminConceptsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminConceptsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConceptCtrlApi.apiAdminConceptsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get By Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminConceptsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminConceptsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConceptCtrlApi.apiAdminConceptsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save
         * @param {string} id 
         * @param {Concept} concept 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminConceptsIdPut(id: string, concept: Concept, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminConceptsIdPut(id, concept, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConceptCtrlApi.apiAdminConceptsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminConceptsReloadPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminConceptsReloadPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConceptCtrlApi.apiAdminConceptsReloadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConceptCtrlApi - factory interface
 */
export const ConceptCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConceptCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Save All
         * @param {Array<Concept>} concept 
         * @param {string} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsBulkPost(concept: Array<Concept>, mode?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.apiAdminConceptsBulkPost(concept, mode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsExportGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Concept>> {
            return localVarFp.apiAdminConceptsExportGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsGet(type?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Concept>> {
            return localVarFp.apiAdminConceptsGet(type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAdminConceptsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get By Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAdminConceptsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save
         * @param {string} id 
         * @param {Concept} concept 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsIdPut(id: string, concept: Concept, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAdminConceptsIdPut(id, concept, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConceptsReloadPost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiAdminConceptsReloadPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConceptCtrlApi - object-oriented interface
 */
export class ConceptCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Save All
     * @param {Array<Concept>} concept 
     * @param {string} [mode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminConceptsBulkPost(concept: Array<Concept>, mode?: string, options?: RawAxiosRequestConfig) {
        return ConceptCtrlApiFp(this.configuration).apiAdminConceptsBulkPost(concept, mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export All
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminConceptsExportGet(options?: RawAxiosRequestConfig) {
        return ConceptCtrlApiFp(this.configuration).apiAdminConceptsExportGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All
     * @param {string} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminConceptsGet(type?: string, options?: RawAxiosRequestConfig) {
        return ConceptCtrlApiFp(this.configuration).apiAdminConceptsGet(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminConceptsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return ConceptCtrlApiFp(this.configuration).apiAdminConceptsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get By Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminConceptsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ConceptCtrlApiFp(this.configuration).apiAdminConceptsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save
     * @param {string} id 
     * @param {Concept} concept 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminConceptsIdPut(id: string, concept: Concept, options?: RawAxiosRequestConfig) {
        return ConceptCtrlApiFp(this.configuration).apiAdminConceptsIdPut(id, concept, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminConceptsReloadPost(options?: RawAxiosRequestConfig) {
        return ConceptCtrlApiFp(this.configuration).apiAdminConceptsReloadPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataCtrlApi - axios parameter creator
 */
export const DataCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Dry Run
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataDryRunInstancePost: async (instance: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataDryRunInstancePost', 'instance', instance)
            // verify required parameter 'promiseQuery' is not null or undefined
            assertParamExists('apiDataDryRunInstancePost', 'promiseQuery', promiseQuery)
            const localVarPath = `/api/data/dry-run/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promiseQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dry Run List Values
         * @param {string} instance 
         * @param {string} key 
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataDryRunListValuesInstanceKeyPost: async (instance: string, key: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataDryRunListValuesInstanceKeyPost', 'instance', instance)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('apiDataDryRunListValuesInstanceKeyPost', 'key', key)
            // verify required parameter 'promiseQuery' is not null or undefined
            assertParamExists('apiDataDryRunListValuesInstanceKeyPost', 'promiseQuery', promiseQuery)
            const localVarPath = `/api/data/dry-run-list-values/{instance}/{key}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promiseQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Data
         * @param {string} instance 
         * @param {string} key 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataInstanceKeyGet: async (instance: string, key: string, lang?: string, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataInstanceKeyGet', 'instance', instance)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('apiDataInstanceKeyGet', 'key', key)
            const localVarPath = `/api/data/{instance}/{key}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Key Data
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataInstancePost: async (instance: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataInstancePost', 'instance', instance)
            // verify required parameter 'promiseQuery' is not null or undefined
            assertParamExists('apiDataInstancePost', 'promiseQuery', promiseQuery)
            const localVarPath = `/api/data/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promiseQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataCtrlApi - functional programming interface
 */
export const DataCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Dry Run
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataDryRunInstancePost(instance: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataDryRunInstancePost(instance, promiseQuery, lang, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataCtrlApi.apiDataDryRunInstancePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Dry Run List Values
         * @param {string} instance 
         * @param {string} key 
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataDryRunListValuesInstanceKeyPost(instance: string, key: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataDryRunListValuesInstanceKeyPost(instance, key, promiseQuery, lang, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataCtrlApi.apiDataDryRunListValuesInstanceKeyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Data
         * @param {string} instance 
         * @param {string} key 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataInstanceKeyGet(instance: string, key: string, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataInstanceKeyGet(instance, key, lang, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataCtrlApi.apiDataInstanceKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Key Data
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataInstancePost(instance: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataInstancePost(instance, promiseQuery, lang, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataCtrlApi.apiDataInstancePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataCtrlApi - factory interface
 */
export const DataCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Dry Run
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataDryRunInstancePost(instance: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiDataDryRunInstancePost(instance, promiseQuery, lang, acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dry Run List Values
         * @param {string} instance 
         * @param {string} key 
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataDryRunListValuesInstanceKeyPost(instance: string, key: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiDataDryRunListValuesInstanceKeyPost(instance, key, promiseQuery, lang, acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Data
         * @param {string} instance 
         * @param {string} key 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataInstanceKeyGet(instance: string, key: string, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): AxiosPromise<DataResultDto> {
            return localVarFp.apiDataInstanceKeyGet(instance, key, lang, acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Key Data
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataInstancePost(instance: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiDataInstancePost(instance, promiseQuery, lang, acceptLanguage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataCtrlApi - object-oriented interface
 */
export class DataCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Dry Run
     * @param {string} instance 
     * @param {PromiseQuery} promiseQuery 
     * @param {string} [lang] 
     * @param {string} [acceptLanguage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataDryRunInstancePost(instance: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig) {
        return DataCtrlApiFp(this.configuration).apiDataDryRunInstancePost(instance, promiseQuery, lang, acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dry Run List Values
     * @param {string} instance 
     * @param {string} key 
     * @param {PromiseQuery} promiseQuery 
     * @param {string} [lang] 
     * @param {string} [acceptLanguage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataDryRunListValuesInstanceKeyPost(instance: string, key: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig) {
        return DataCtrlApiFp(this.configuration).apiDataDryRunListValuesInstanceKeyPost(instance, key, promiseQuery, lang, acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Data
     * @param {string} instance 
     * @param {string} key 
     * @param {string} [lang] 
     * @param {string} [acceptLanguage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataInstanceKeyGet(instance: string, key: string, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig) {
        return DataCtrlApiFp(this.configuration).apiDataInstanceKeyGet(instance, key, lang, acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Key Data
     * @param {string} instance 
     * @param {PromiseQuery} promiseQuery 
     * @param {string} [lang] 
     * @param {string} [acceptLanguage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataInstancePost(instance: string, promiseQuery: PromiseQuery, lang?: string, acceptLanguage?: string, options?: RawAxiosRequestConfig) {
        return DataCtrlApiFp(this.configuration).apiDataInstancePost(instance, promiseQuery, lang, acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataStatsCtrlApi - axios parameter creator
 */
export const DataStatsCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Db Stats Dynamic
         * @param {string} instance 
         * @param {DbStatQueryDto} dbStatQueryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatsInstancePost: async (instance: string, dbStatQueryDto: DbStatQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiStatsInstancePost', 'instance', instance)
            // verify required parameter 'dbStatQueryDto' is not null or undefined
            assertParamExists('apiStatsInstancePost', 'dbStatQueryDto', dbStatQueryDto)
            const localVarPath = `/api/stats/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dbStatQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataStatsCtrlApi - functional programming interface
 */
export const DataStatsCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataStatsCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Db Stats Dynamic
         * @param {string} instance 
         * @param {DbStatQueryDto} dbStatQueryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStatsInstancePost(instance: string, dbStatQueryDto: DbStatQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DbStatDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStatsInstancePost(instance, dbStatQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataStatsCtrlApi.apiStatsInstancePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataStatsCtrlApi - factory interface
 */
export const DataStatsCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataStatsCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Db Stats Dynamic
         * @param {string} instance 
         * @param {DbStatQueryDto} dbStatQueryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatsInstancePost(instance: string, dbStatQueryDto: DbStatQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<DbStatDto>> {
            return localVarFp.apiStatsInstancePost(instance, dbStatQueryDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataStatsCtrlApi - object-oriented interface
 */
export class DataStatsCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get Db Stats Dynamic
     * @param {string} instance 
     * @param {DbStatQueryDto} dbStatQueryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStatsInstancePost(instance: string, dbStatQueryDto: DbStatQueryDto, options?: RawAxiosRequestConfig) {
        return DataStatsCtrlApiFp(this.configuration).apiStatsInstancePost(instance, dbStatQueryDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImportDataCtrlApi - axios parameter creator
 */
export const ImportDataCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Finish Load
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataLoadInstanceFinishPost: async (instance: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataLoadInstanceFinishPost', 'instance', instance)
            const localVarPath = `/api/data/load/{instance}/finish`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Load Data
         * @param {string} instance 
         * @param {Array<DataDto>} dataDto 
         * @param {string} [bdd] 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataLoadInstancePost: async (instance: string, dataDto: Array<DataDto>, bdd?: string, filename?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataLoadInstancePost', 'instance', instance)
            // verify required parameter 'dataDto' is not null or undefined
            assertParamExists('apiDataLoadInstancePost', 'dataDto', dataDto)
            const localVarPath = `/api/data/load/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bdd !== undefined) {
                localVarQueryParameter['bdd'] = bdd;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Truncate Data
         * @param {string} instance 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataLoadInstanceTruncateGet: async (instance: string, filename?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataLoadInstanceTruncateGet', 'instance', instance)
            const localVarPath = `/api/data/load/{instance}/truncate`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportDataCtrlApi - functional programming interface
 */
export const ImportDataCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImportDataCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Finish Load
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataLoadInstanceFinishPost(instance: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataLoadInstanceFinishPost(instance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportDataCtrlApi.apiDataLoadInstanceFinishPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Load Data
         * @param {string} instance 
         * @param {Array<DataDto>} dataDto 
         * @param {string} [bdd] 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataLoadInstancePost(instance: string, dataDto: Array<DataDto>, bdd?: string, filename?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataLoadInstancePost(instance, dataDto, bdd, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportDataCtrlApi.apiDataLoadInstancePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Truncate Data
         * @param {string} instance 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataLoadInstanceTruncateGet(instance: string, filename?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataLoadInstanceTruncateGet(instance, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportDataCtrlApi.apiDataLoadInstanceTruncateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImportDataCtrlApi - factory interface
 */
export const ImportDataCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImportDataCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Finish Load
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataLoadInstanceFinishPost(instance: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiDataLoadInstanceFinishPost(instance, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Load Data
         * @param {string} instance 
         * @param {Array<DataDto>} dataDto 
         * @param {string} [bdd] 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataLoadInstancePost(instance: string, dataDto: Array<DataDto>, bdd?: string, filename?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiDataLoadInstancePost(instance, dataDto, bdd, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Truncate Data
         * @param {string} instance 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataLoadInstanceTruncateGet(instance: string, filename?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDataLoadInstanceTruncateGet(instance, filename, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImportDataCtrlApi - object-oriented interface
 */
export class ImportDataCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Finish Load
     * @param {string} instance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataLoadInstanceFinishPost(instance: string, options?: RawAxiosRequestConfig) {
        return ImportDataCtrlApiFp(this.configuration).apiDataLoadInstanceFinishPost(instance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Load Data
     * @param {string} instance 
     * @param {Array<DataDto>} dataDto 
     * @param {string} [bdd] 
     * @param {string} [filename] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataLoadInstancePost(instance: string, dataDto: Array<DataDto>, bdd?: string, filename?: string, options?: RawAxiosRequestConfig) {
        return ImportDataCtrlApiFp(this.configuration).apiDataLoadInstancePost(instance, dataDto, bdd, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Truncate Data
     * @param {string} instance 
     * @param {string} [filename] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataLoadInstanceTruncateGet(instance: string, filename?: string, options?: RawAxiosRequestConfig) {
        return ImportDataCtrlApiFp(this.configuration).apiDataLoadInstanceTruncateGet(instance, filename, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ListCtrlApi - axios parameter creator
 */
export const ListCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get List Db
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListDbInstanceGet: async (instance: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataListDbInstanceGet', 'instance', instance)
            const localVarPath = `/api/data/list/db/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get List Dimensions
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListDimensionsInstancePost: async (instance: string, promiseQuery: PromiseQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataListDimensionsInstancePost', 'instance', instance)
            // verify required parameter 'promiseQuery' is not null or undefined
            assertParamExists('apiDataListDimensionsInstancePost', 'promiseQuery', promiseQuery)
            const localVarPath = `/api/data/list/dimensions/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promiseQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Loaded Files
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListFilesInstanceGet: async (instance: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataListFilesInstanceGet', 'instance', instance)
            const localVarPath = `/api/data/list/files/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get List Geo
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListGeoInstancePost: async (instance: string, promiseQuery: PromiseQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataListGeoInstancePost', 'instance', instance)
            // verify required parameter 'promiseQuery' is not null or undefined
            assertParamExists('apiDataListGeoInstancePost', 'promiseQuery', promiseQuery)
            const localVarPath = `/api/data/list/geo/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promiseQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get List Values
         * @param {string} instance 
         * @param {string} key 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListKeysInstanceKeyPost: async (instance: string, key: string, promiseQuery: PromiseQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataListKeysInstanceKeyPost', 'instance', instance)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('apiDataListKeysInstanceKeyPost', 'key', key)
            // verify required parameter 'promiseQuery' is not null or undefined
            assertParamExists('apiDataListKeysInstanceKeyPost', 'promiseQuery', promiseQuery)
            const localVarPath = `/api/data/list/keys/{instance}/{key}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promiseQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get List Tags
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListTagsInstancePost: async (instance: string, promiseQuery: PromiseQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiDataListTagsInstancePost', 'instance', instance)
            // verify required parameter 'promiseQuery' is not null or undefined
            assertParamExists('apiDataListTagsInstancePost', 'promiseQuery', promiseQuery)
            const localVarPath = `/api/data/list/tags/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promiseQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListCtrlApi - functional programming interface
 */
export const ListCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ListCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get List Db
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataListDbInstanceGet(instance: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataListDbInstanceGet(instance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ListCtrlApi.apiDataListDbInstanceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get List Dimensions
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataListDimensionsInstancePost(instance: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListResultDtoMapStringListString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataListDimensionsInstancePost(instance, promiseQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ListCtrlApi.apiDataListDimensionsInstancePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Loaded Files
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataListFilesInstanceGet(instance: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataListFilesInstanceGet(instance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ListCtrlApi.apiDataListFilesInstanceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get List Geo
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataListGeoInstancePost(instance: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListResultDtoListString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataListGeoInstancePost(instance, promiseQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ListCtrlApi.apiDataListGeoInstancePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get List Values
         * @param {string} instance 
         * @param {string} key 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataListKeysInstanceKeyPost(instance: string, key: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListResultDtoListString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataListKeysInstanceKeyPost(instance, key, promiseQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ListCtrlApi.apiDataListKeysInstanceKeyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get List Tags
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataListTagsInstancePost(instance: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListResultDtoListString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataListTagsInstancePost(instance, promiseQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ListCtrlApi.apiDataListTagsInstancePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ListCtrlApi - factory interface
 */
export const ListCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ListCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get List Db
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListDbInstanceGet(instance: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiDataListDbInstanceGet(instance, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get List Dimensions
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListDimensionsInstancePost(instance: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig): AxiosPromise<ListResultDtoMapStringListString> {
            return localVarFp.apiDataListDimensionsInstancePost(instance, promiseQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Loaded Files
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListFilesInstanceGet(instance: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<string>; }> {
            return localVarFp.apiDataListFilesInstanceGet(instance, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get List Geo
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListGeoInstancePost(instance: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig): AxiosPromise<ListResultDtoListString> {
            return localVarFp.apiDataListGeoInstancePost(instance, promiseQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get List Values
         * @param {string} instance 
         * @param {string} key 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListKeysInstanceKeyPost(instance: string, key: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig): AxiosPromise<ListResultDtoListString> {
            return localVarFp.apiDataListKeysInstanceKeyPost(instance, key, promiseQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get List Tags
         * @param {string} instance 
         * @param {PromiseQuery} promiseQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataListTagsInstancePost(instance: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig): AxiosPromise<ListResultDtoListString> {
            return localVarFp.apiDataListTagsInstancePost(instance, promiseQuery, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ListCtrlApi - object-oriented interface
 */
export class ListCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get List Db
     * @param {string} instance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataListDbInstanceGet(instance: string, options?: RawAxiosRequestConfig) {
        return ListCtrlApiFp(this.configuration).apiDataListDbInstanceGet(instance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get List Dimensions
     * @param {string} instance 
     * @param {PromiseQuery} promiseQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataListDimensionsInstancePost(instance: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig) {
        return ListCtrlApiFp(this.configuration).apiDataListDimensionsInstancePost(instance, promiseQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Loaded Files
     * @param {string} instance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataListFilesInstanceGet(instance: string, options?: RawAxiosRequestConfig) {
        return ListCtrlApiFp(this.configuration).apiDataListFilesInstanceGet(instance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get List Geo
     * @param {string} instance 
     * @param {PromiseQuery} promiseQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataListGeoInstancePost(instance: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig) {
        return ListCtrlApiFp(this.configuration).apiDataListGeoInstancePost(instance, promiseQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get List Values
     * @param {string} instance 
     * @param {string} key 
     * @param {PromiseQuery} promiseQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataListKeysInstanceKeyPost(instance: string, key: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig) {
        return ListCtrlApiFp(this.configuration).apiDataListKeysInstanceKeyPost(instance, key, promiseQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get List Tags
     * @param {string} instance 
     * @param {PromiseQuery} promiseQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDataListTagsInstancePost(instance: string, promiseQuery: PromiseQuery, options?: RawAxiosRequestConfig) {
        return ListCtrlApiFp(this.configuration).apiDataListTagsInstancePost(instance, promiseQuery, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotifyCtrlApi - axios parameter creator
 */
export const NotifyCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deprecated — use POST /notify/contact
         * @param {ContactDto} contactDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiContactSendPost: async (contactDto: ContactDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactDto' is not null or undefined
            assertParamExists('apiContactSendPost', 'contactDto', contactDto)
            const localVarPath = `/api/contact/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/bug-report
         * @param {BugReportDto} bugReportDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiDiscordNotifyBugReportPost: async (bugReportDto: BugReportDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bugReportDto' is not null or undefined
            assertParamExists('apiDiscordNotifyBugReportPost', 'bugReportDto', bugReportDto)
            const localVarPath = `/api/discord/notify/bug-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bugReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/contact
         * @param {ContactDto} contactDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiDiscordNotifyContactPost: async (contactDto: ContactDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactDto' is not null or undefined
            assertParamExists('apiDiscordNotifyContactPost', 'contactDto', contactDto)
            const localVarPath = `/api/discord/notify/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/password-reset
         * @param {PasswordResetRequestDto} passwordResetRequestDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiDiscordNotifyPasswordResetPost: async (passwordResetRequestDto: PasswordResetRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetRequestDto' is not null or undefined
            assertParamExists('apiDiscordNotifyPasswordResetPost', 'passwordResetRequestDto', passwordResetRequestDto)
            const localVarPath = `/api/discord/notify/password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/user-creation
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiDiscordNotifyUserCreationPost: async (userDto: UserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDto' is not null or undefined
            assertParamExists('apiDiscordNotifyUserCreationPost', 'userDto', userDto)
            const localVarPath = `/api/discord/notify/user-creation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notify Bug Report
         * @param {BugReportDto} bugReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotifyBugReportPost: async (bugReportDto: BugReportDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bugReportDto' is not null or undefined
            assertParamExists('apiNotifyBugReportPost', 'bugReportDto', bugReportDto)
            const localVarPath = `/api/notify/bug-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bugReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notify Contact
         * @param {ContactDto} contactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotifyContactPost: async (contactDto: ContactDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactDto' is not null or undefined
            assertParamExists('apiNotifyContactPost', 'contactDto', contactDto)
            const localVarPath = `/api/notify/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notify Password Reset
         * @param {PasswordResetRequestDto} passwordResetRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotifyPasswordResetPost: async (passwordResetRequestDto: PasswordResetRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetRequestDto' is not null or undefined
            assertParamExists('apiNotifyPasswordResetPost', 'passwordResetRequestDto', passwordResetRequestDto)
            const localVarPath = `/api/notify/password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notify User Creation
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotifyUserCreationPost: async (userDto: UserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDto' is not null or undefined
            assertParamExists('apiNotifyUserCreationPost', 'userDto', userDto)
            const localVarPath = `/api/notify/user-creation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotifyCtrlApi - functional programming interface
 */
export const NotifyCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotifyCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deprecated — use POST /notify/contact
         * @param {ContactDto} contactDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiContactSendPost(contactDto: ContactDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContactSendPost(contactDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotifyCtrlApi.apiContactSendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/bug-report
         * @param {BugReportDto} bugReportDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiDiscordNotifyBugReportPost(bugReportDto: BugReportDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDiscordNotifyBugReportPost(bugReportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotifyCtrlApi.apiDiscordNotifyBugReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/contact
         * @param {ContactDto} contactDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiDiscordNotifyContactPost(contactDto: ContactDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDiscordNotifyContactPost(contactDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotifyCtrlApi.apiDiscordNotifyContactPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/password-reset
         * @param {PasswordResetRequestDto} passwordResetRequestDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiDiscordNotifyPasswordResetPost(passwordResetRequestDto: PasswordResetRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDiscordNotifyPasswordResetPost(passwordResetRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotifyCtrlApi.apiDiscordNotifyPasswordResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/user-creation
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiDiscordNotifyUserCreationPost(userDto: UserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDiscordNotifyUserCreationPost(userDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotifyCtrlApi.apiDiscordNotifyUserCreationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Notify Bug Report
         * @param {BugReportDto} bugReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotifyBugReportPost(bugReportDto: BugReportDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotifyBugReportPost(bugReportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotifyCtrlApi.apiNotifyBugReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Notify Contact
         * @param {ContactDto} contactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotifyContactPost(contactDto: ContactDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotifyContactPost(contactDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotifyCtrlApi.apiNotifyContactPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Notify Password Reset
         * @param {PasswordResetRequestDto} passwordResetRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotifyPasswordResetPost(passwordResetRequestDto: PasswordResetRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotifyPasswordResetPost(passwordResetRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotifyCtrlApi.apiNotifyPasswordResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Notify User Creation
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotifyUserCreationPost(userDto: UserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotifyUserCreationPost(userDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotifyCtrlApi.apiNotifyUserCreationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotifyCtrlApi - factory interface
 */
export const NotifyCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotifyCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Deprecated — use POST /notify/contact
         * @param {ContactDto} contactDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiContactSendPost(contactDto: ContactDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiContactSendPost(contactDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/bug-report
         * @param {BugReportDto} bugReportDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiDiscordNotifyBugReportPost(bugReportDto: BugReportDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiDiscordNotifyBugReportPost(bugReportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/contact
         * @param {ContactDto} contactDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiDiscordNotifyContactPost(contactDto: ContactDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiDiscordNotifyContactPost(contactDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/password-reset
         * @param {PasswordResetRequestDto} passwordResetRequestDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiDiscordNotifyPasswordResetPost(passwordResetRequestDto: PasswordResetRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiDiscordNotifyPasswordResetPost(passwordResetRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deprecated — use POST /notify/user-creation
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiDiscordNotifyUserCreationPost(userDto: UserDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiDiscordNotifyUserCreationPost(userDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notify Bug Report
         * @param {BugReportDto} bugReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotifyBugReportPost(bugReportDto: BugReportDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiNotifyBugReportPost(bugReportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notify Contact
         * @param {ContactDto} contactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotifyContactPost(contactDto: ContactDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiNotifyContactPost(contactDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notify Password Reset
         * @param {PasswordResetRequestDto} passwordResetRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotifyPasswordResetPost(passwordResetRequestDto: PasswordResetRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiNotifyPasswordResetPost(passwordResetRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notify User Creation
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotifyUserCreationPost(userDto: UserDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiNotifyUserCreationPost(userDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotifyCtrlApi - object-oriented interface
 */
export class NotifyCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Deprecated — use POST /notify/contact
     * @param {ContactDto} contactDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public apiContactSendPost(contactDto: ContactDto, options?: RawAxiosRequestConfig) {
        return NotifyCtrlApiFp(this.configuration).apiContactSendPost(contactDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deprecated — use POST /notify/bug-report
     * @param {BugReportDto} bugReportDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public apiDiscordNotifyBugReportPost(bugReportDto: BugReportDto, options?: RawAxiosRequestConfig) {
        return NotifyCtrlApiFp(this.configuration).apiDiscordNotifyBugReportPost(bugReportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deprecated — use POST /notify/contact
     * @param {ContactDto} contactDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public apiDiscordNotifyContactPost(contactDto: ContactDto, options?: RawAxiosRequestConfig) {
        return NotifyCtrlApiFp(this.configuration).apiDiscordNotifyContactPost(contactDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deprecated — use POST /notify/password-reset
     * @param {PasswordResetRequestDto} passwordResetRequestDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public apiDiscordNotifyPasswordResetPost(passwordResetRequestDto: PasswordResetRequestDto, options?: RawAxiosRequestConfig) {
        return NotifyCtrlApiFp(this.configuration).apiDiscordNotifyPasswordResetPost(passwordResetRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deprecated — use POST /notify/user-creation
     * @param {UserDto} userDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public apiDiscordNotifyUserCreationPost(userDto: UserDto, options?: RawAxiosRequestConfig) {
        return NotifyCtrlApiFp(this.configuration).apiDiscordNotifyUserCreationPost(userDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notify Bug Report
     * @param {BugReportDto} bugReportDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotifyBugReportPost(bugReportDto: BugReportDto, options?: RawAxiosRequestConfig) {
        return NotifyCtrlApiFp(this.configuration).apiNotifyBugReportPost(bugReportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notify Contact
     * @param {ContactDto} contactDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotifyContactPost(contactDto: ContactDto, options?: RawAxiosRequestConfig) {
        return NotifyCtrlApiFp(this.configuration).apiNotifyContactPost(contactDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notify Password Reset
     * @param {PasswordResetRequestDto} passwordResetRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotifyPasswordResetPost(passwordResetRequestDto: PasswordResetRequestDto, options?: RawAxiosRequestConfig) {
        return NotifyCtrlApiFp(this.configuration).apiNotifyPasswordResetPost(passwordResetRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notify User Creation
     * @param {UserDto} userDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotifyUserCreationPost(userDto: UserDto, options?: RawAxiosRequestConfig) {
        return NotifyCtrlApiFp(this.configuration).apiNotifyUserCreationPost(userDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OntologyConfigCtrlApi - axios parameter creator
 */
export const OntologyConfigCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConfigGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set
         * @param {{ [key: string]: boolean; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConfigPut: async (requestBody: { [key: string]: boolean; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('apiAdminConfigPut', 'requestBody', requestBody)
            const localVarPath = `/api/admin/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OntologyConfigCtrlApi - functional programming interface
 */
export const OntologyConfigCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OntologyConfigCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminConfigGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminConfigGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OntologyConfigCtrlApi.apiAdminConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set
         * @param {{ [key: string]: boolean; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminConfigPut(requestBody: { [key: string]: boolean; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminConfigPut(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OntologyConfigCtrlApi.apiAdminConfigPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OntologyConfigCtrlApi - factory interface
 */
export const OntologyConfigCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OntologyConfigCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConfigGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.apiAdminConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set
         * @param {{ [key: string]: boolean; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminConfigPut(requestBody: { [key: string]: boolean; }, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.apiAdminConfigPut(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OntologyConfigCtrlApi - object-oriented interface
 */
export class OntologyConfigCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminConfigGet(options?: RawAxiosRequestConfig) {
        return OntologyConfigCtrlApiFp(this.configuration).apiAdminConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set
     * @param {{ [key: string]: boolean; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminConfigPut(requestBody: { [key: string]: boolean; }, options?: RawAxiosRequestConfig) {
        return OntologyConfigCtrlApiFp(this.configuration).apiAdminConfigPut(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrphansCtrlApi - axios parameter creator
 */
export const OrphansCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Detect
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphansInstanceGet: async (instance: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiAdminOrphansInstanceGet', 'instance', instance)
            const localVarPath = `/api/admin/orphans/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrphansCtrlApi - functional programming interface
 */
export const OrphansCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrphansCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Detect
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminOrphansInstanceGet(instance: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminOrphansInstanceGet(instance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrphansCtrlApi.apiAdminOrphansInstanceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrphansCtrlApi - factory interface
 */
export const OrphansCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrphansCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Detect
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphansInstanceGet(instance: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.apiAdminOrphansInstanceGet(instance, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrphansCtrlApi - object-oriented interface
 */
export class OrphansCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Detect
     * @param {string} instance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminOrphansInstanceGet(instance: string, options?: RawAxiosRequestConfig) {
        return OrphansCtrlApiFp(this.configuration).apiAdminOrphansInstanceGet(instance, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrackingCtrlApi - axios parameter creator
 */
export const TrackingCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Recent Sessions
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTrackingRecentGet: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tracking/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTrackingSessionSessionIdGet: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiTrackingSessionSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/api/tracking/session/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Track
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTrackingTrackPost: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('apiTrackingTrackPost', 'body', body)
            const localVarPath = `/api/tracking/track`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete By User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTrackingUserUserIdDelete: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiTrackingUserUserIdDelete', 'userId', userId)
            const localVarPath = `/api/tracking/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Sessions By User
         * @param {string} userId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTrackingUserUserIdGet: async (userId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiTrackingUserUserIdGet', 'userId', userId)
            const localVarPath = `/api/tracking/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackingCtrlApi - functional programming interface
 */
export const TrackingCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrackingCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Recent Sessions
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTrackingRecentGet(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTrackingRecentGet(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingCtrlApi.apiTrackingRecentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTrackingSessionSessionIdGet(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTrackingSessionSessionIdGet(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingCtrlApi.apiTrackingSessionSessionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Track
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTrackingTrackPost(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTrackingTrackPost(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingCtrlApi.apiTrackingTrackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete By User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTrackingUserUserIdDelete(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTrackingUserUserIdDelete(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingCtrlApi.apiTrackingUserUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Sessions By User
         * @param {string} userId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTrackingUserUserIdGet(userId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTrackingUserUserIdGet(userId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingCtrlApi.apiTrackingUserUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrackingCtrlApi - factory interface
 */
export const TrackingCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrackingCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Recent Sessions
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTrackingRecentGet(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiTrackingRecentGet(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTrackingSessionSessionIdGet(sessionId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiTrackingSessionSessionIdGet(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Track
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTrackingTrackPost(body: any, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiTrackingTrackPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete By User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTrackingUserUserIdDelete(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiTrackingUserUserIdDelete(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Sessions By User
         * @param {string} userId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTrackingUserUserIdGet(userId: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiTrackingUserUserIdGet(userId, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrackingCtrlApi - object-oriented interface
 */
export class TrackingCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get Recent Sessions
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTrackingRecentGet(limit?: number, options?: RawAxiosRequestConfig) {
        return TrackingCtrlApiFp(this.configuration).apiTrackingRecentGet(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Session
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTrackingSessionSessionIdGet(sessionId: string, options?: RawAxiosRequestConfig) {
        return TrackingCtrlApiFp(this.configuration).apiTrackingSessionSessionIdGet(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Track
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTrackingTrackPost(body: any, options?: RawAxiosRequestConfig) {
        return TrackingCtrlApiFp(this.configuration).apiTrackingTrackPost(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete By User
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTrackingUserUserIdDelete(userId: string, options?: RawAxiosRequestConfig) {
        return TrackingCtrlApiFp(this.configuration).apiTrackingUserUserIdDelete(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Sessions By User
     * @param {string} userId 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTrackingUserUserIdGet(userId: string, limit?: number, options?: RawAxiosRequestConfig) {
        return TrackingCtrlApiFp(this.configuration).apiTrackingUserUserIdGet(userId, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TranslatePreviewCtrlApi - axios parameter creator
 */
export const TranslatePreviewCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Preview
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTranslatePreviewPost: async (promiseQuery: PromiseQuery, lang?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promiseQuery' is not null or undefined
            assertParamExists('apiTranslatePreviewPost', 'promiseQuery', promiseQuery)
            const localVarPath = `/api/translate/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promiseQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranslatePreviewCtrlApi - functional programming interface
 */
export const TranslatePreviewCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranslatePreviewCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Preview
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTranslatePreviewPost(promiseQuery: PromiseQuery, lang?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTranslatePreviewPost(promiseQuery, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslatePreviewCtrlApi.apiTranslatePreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TranslatePreviewCtrlApi - factory interface
 */
export const TranslatePreviewCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranslatePreviewCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Preview
         * @param {PromiseQuery} promiseQuery 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTranslatePreviewPost(promiseQuery: PromiseQuery, lang?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.apiTranslatePreviewPost(promiseQuery, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranslatePreviewCtrlApi - object-oriented interface
 */
export class TranslatePreviewCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Preview
     * @param {PromiseQuery} promiseQuery 
     * @param {string} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTranslatePreviewPost(promiseQuery: PromiseQuery, lang?: string, options?: RawAxiosRequestConfig) {
        return TranslatePreviewCtrlApiFp(this.configuration).apiTranslatePreviewPost(promiseQuery, lang, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ViewDashboardManagerCtrlApi - axios parameter creator
 */
export const ViewDashboardManagerCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ViewDashboardManagerCtrlApi - functional programming interface
 */
export const ViewDashboardManagerCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ViewDashboardManagerCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDashboardsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardModelDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDashboardsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewDashboardManagerCtrlApi.apiDashboardsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ViewDashboardManagerCtrlApi - factory interface
 */
export const ViewDashboardManagerCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ViewDashboardManagerCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDashboardsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<DashboardModelDto>> {
            return localVarFp.apiDashboardsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ViewDashboardManagerCtrlApi - object-oriented interface
 */
export class ViewDashboardManagerCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get All
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDashboardsGet(options?: RawAxiosRequestConfig) {
        return ViewDashboardManagerCtrlApiFp(this.configuration).apiDashboardsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ViewManagerCtrlApi - axios parameter creator
 */
export const ViewManagerCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Find All
         * @param {string} instance 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewsFindInstanceGet: async (instance: string, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiViewsFindInstanceGet', 'instance', instance)
            const localVarPath = `/api/views/find/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiViewsIdDelete', 'id', id)
            const localVarPath = `/api/views/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewsInstanceGet: async (instance: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instance' is not null or undefined
            assertParamExists('apiViewsInstanceGet', 'instance', instance)
            const localVarPath = `/api/views/{instance}`
                .replace(`{${"instance"}}`, encodeURIComponent(String(instance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewsOneIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiViewsOneIdGet', 'id', id)
            const localVarPath = `/api/views/one/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update One
         * @param {ViewDto} viewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewsPost: async (viewDto: ViewDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'viewDto' is not null or undefined
            assertParamExists('apiViewsPost', 'viewDto', viewDto)
            const localVarPath = `/api/views`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(viewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ViewManagerCtrlApi - functional programming interface
 */
export const ViewManagerCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ViewManagerCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Find All
         * @param {string} instance 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiViewsFindInstanceGet(instance: string, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiViewsFindInstanceGet(instance, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewManagerCtrlApi.apiViewsFindInstanceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiViewsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiViewsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewManagerCtrlApi.apiViewsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiViewsInstanceGet(instance: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiViewsInstanceGet(instance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewManagerCtrlApi.apiViewsInstanceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiViewsOneIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiViewsOneIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewManagerCtrlApi.apiViewsOneIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update One
         * @param {ViewDto} viewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiViewsPost(viewDto: ViewDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiViewsPost(viewDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewManagerCtrlApi.apiViewsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ViewManagerCtrlApi - factory interface
 */
export const ViewManagerCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ViewManagerCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Find All
         * @param {string} instance 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewsFindInstanceGet(instance: string, q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ViewDto>> {
            return localVarFp.apiViewsFindInstanceGet(instance, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiViewsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All
         * @param {string} instance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewsInstanceGet(instance: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ViewDto>> {
            return localVarFp.apiViewsInstanceGet(instance, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get One
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewsOneIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ViewDto> {
            return localVarFp.apiViewsOneIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update One
         * @param {ViewDto} viewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewsPost(viewDto: ViewDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiViewsPost(viewDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ViewManagerCtrlApi - object-oriented interface
 */
export class ViewManagerCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Find All
     * @param {string} instance 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiViewsFindInstanceGet(instance: string, q?: string, options?: RawAxiosRequestConfig) {
        return ViewManagerCtrlApiFp(this.configuration).apiViewsFindInstanceGet(instance, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete One
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiViewsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return ViewManagerCtrlApiFp(this.configuration).apiViewsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All
     * @param {string} instance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiViewsInstanceGet(instance: string, options?: RawAxiosRequestConfig) {
        return ViewManagerCtrlApiFp(this.configuration).apiViewsInstanceGet(instance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get One
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiViewsOneIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ViewManagerCtrlApiFp(this.configuration).apiViewsOneIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update One
     * @param {ViewDto} viewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiViewsPost(viewDto: ViewDto, options?: RawAxiosRequestConfig) {
        return ViewManagerCtrlApiFp(this.configuration).apiViewsPost(viewDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WsAuthCtrlApi - axios parameter creator
 */
export const WsAuthCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Issue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAuthPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ws/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WsAuthCtrlApi - functional programming interface
 */
export const WsAuthCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WsAuthCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Issue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWsAuthPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WsAuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWsAuthPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WsAuthCtrlApi.apiWsAuthPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WsAuthCtrlApi - factory interface
 */
export const WsAuthCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WsAuthCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Issue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAuthPost(options?: RawAxiosRequestConfig): AxiosPromise<WsAuthResponse> {
            return localVarFp.apiWsAuthPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WsAuthCtrlApi - object-oriented interface
 */
export class WsAuthCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Issue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiWsAuthPost(options?: RawAxiosRequestConfig) {
        return WsAuthCtrlApiFp(this.configuration).apiWsAuthPost(options).then((request) => request(this.axios, this.basePath));
    }
}



